// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.mat-ripple {
  overflow: hidden;
  position: relative;
}
.mat-ripple:not(:empty) {
  transform: translateZ(0);
}

.mat-ripple.mat-ripple-unbounded {
  overflow: visible;
}

.mat-ripple-element {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  transition: opacity, transform 0ms cubic-bezier(0, 0, 0.2, 1);
  transform: scale3d(0, 0, 0);
}
.cdk-high-contrast-active .mat-ripple-element {
  display: none;
}

.cdk-visually-hidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  white-space: nowrap;
  outline: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  left: 0;
}
[dir=rtl] .cdk-visually-hidden {
  left: auto;
  right: 0;
}

.cdk-overlay-container, .cdk-global-overlay-wrapper {
  pointer-events: none;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.cdk-overlay-container {
  position: fixed;
  z-index: 1000;
}
.cdk-overlay-container:empty {
  display: none;
}

.cdk-global-overlay-wrapper {
  display: flex;
  position: absolute;
  z-index: 1000;
}

.cdk-overlay-pane {
  position: absolute;
  pointer-events: auto;
  box-sizing: border-box;
  z-index: 1000;
  display: flex;
  max-width: 100%;
  max-height: 100%;
}

.cdk-overlay-backdrop {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  pointer-events: auto;
  -webkit-tap-highlight-color: transparent;
  transition: opacity 400ms cubic-bezier(0.25, 0.8, 0.25, 1);
  opacity: 0;
}
.cdk-overlay-backdrop.cdk-overlay-backdrop-showing {
  opacity: 1;
}
.cdk-high-contrast-active .cdk-overlay-backdrop.cdk-overlay-backdrop-showing {
  opacity: 0.6;
}

.cdk-overlay-dark-backdrop {
  background: rgba(0, 0, 0, 0.32);
}

.cdk-overlay-transparent-backdrop {
  transition: visibility 1ms linear, opacity 1ms linear;
  visibility: hidden;
  opacity: 1;
}
.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {
  opacity: 0;
  visibility: visible;
}

.cdk-overlay-backdrop-noop-animation {
  transition: none;
}

.cdk-overlay-connected-position-bounding-box {
  position: absolute;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  min-width: 1px;
  min-height: 1px;
}

.cdk-global-scrollblock {
  position: fixed;
  width: 100%;
  overflow-y: scroll;
}

textarea.cdk-textarea-autosize {
  resize: none;
}

textarea.cdk-textarea-autosize-measuring {
  padding: 2px 0 !important;
  box-sizing: content-box !important;
  height: auto !important;
  overflow: hidden !important;
}

textarea.cdk-textarea-autosize-measuring-firefox {
  padding: 2px 0 !important;
  box-sizing: content-box !important;
  height: 0 !important;
}

@keyframes cdk-text-field-autofill-start { /*!*/ }
@keyframes cdk-text-field-autofill-end { /*!*/ }
.cdk-text-field-autofill-monitored:-webkit-autofill {
  animation: cdk-text-field-autofill-start 0s 1ms;
}

.cdk-text-field-autofill-monitored:not(:-webkit-autofill) {
  animation: cdk-text-field-autofill-end 0s 1ms;
}

.mat-focus-indicator {
  position: relative;
}
.mat-focus-indicator::before {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  box-sizing: border-box;
  pointer-events: none;
  display: var(--mat-focus-indicator-display, none);
  border: var(--mat-focus-indicator-border-width, 3px) var(--mat-focus-indicator-border-style, solid) var(--mat-focus-indicator-border-color, transparent);
  border-radius: var(--mat-focus-indicator-border-radius, 4px);
}
.mat-focus-indicator:focus::before {
  content: "";
}

.cdk-high-contrast-active {
  --mat-focus-indicator-display: block;
}

.mat-mdc-focus-indicator {
  position: relative;
}
.mat-mdc-focus-indicator::before {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  box-sizing: border-box;
  pointer-events: none;
  display: var(--mat-mdc-focus-indicator-display, none);
  border: var(--mat-mdc-focus-indicator-border-width, 3px) var(--mat-mdc-focus-indicator-border-style, solid) var(--mat-mdc-focus-indicator-border-color, transparent);
  border-radius: var(--mat-mdc-focus-indicator-border-radius, 4px);
}
.mat-mdc-focus-indicator:focus::before {
  content: "";
}

.cdk-high-contrast-active {
  --mat-mdc-focus-indicator-display: block;
}

/* 
	Colors values 
	300 = tint
	500 = default
	700 = shade
*/
body {
  font-family: "Barlow", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
}

h1 {
  font-size: 64px;
  line-height: 78px;
}

h2 {
  font-size: 56px;
  line-height: 68px;
}

h3 {
  font-size: 48px;
  line-height: 58px;
}

h4 {
  font-size: 40px;
  line-height: 48px;
}

h5 {
  font-size: 32px;
  line-height: 39px;
}

h6 {
  font-size: 24px;
  line-height: 29px;
}

a {
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  color: rgb(174, 15, 10);
  cursor: pointer;
  text-decoration: underline;
}

caption {
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
}

th {
  font-weight: 700;
  cursor: pointer;
}

/* 
	Colors values 
	300 = tint
	500 = default
	700 = shade
*/
.p-0 {
  padding: 0px;
}

.pt-0 {
  padding-top: 0px;
}

.pr-0 {
  padding-right: 0px;
}

.pb-0 {
  padding-bottom: 0px;
}

.pl-0 {
  padding-left: 0px;
}

.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}

.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}

.m-0 {
  margin: 0px;
}

.mt-0 {
  margin-top: 0px;
}

.mr-0 {
  margin-right: 0px;
}

.mb-0 {
  margin-bottom: 0px;
}

.ml-0 {
  margin-left: 0px;
}

.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}

.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}

.p-1 {
  padding: 8px;
}

.pt-1 {
  padding-top: 8px;
}

.pr-1 {
  padding-right: 8px;
}

.pb-1 {
  padding-bottom: 8px;
}

.pl-1 {
  padding-left: 8px;
}

.px-1 {
  padding-left: 8px;
  padding-right: 8px;
}

.py-1 {
  padding-top: 8px;
  padding-bottom: 8px;
}

.m-1 {
  margin: 8px;
}

.mt-1 {
  margin-top: 8px;
}

.mr-1 {
  margin-right: 8px;
}

.mb-1 {
  margin-bottom: 8px;
}

.ml-1 {
  margin-left: 8px;
}

.mx-1 {
  margin-left: 8px;
  margin-right: 8px;
}

.my-1 {
  margin-top: 8px;
  margin-bottom: 8px;
}

.p-2 {
  padding: 16px;
}

.pt-2 {
  padding-top: 16px;
}

.pr-2 {
  padding-right: 16px;
}

.pb-2 {
  padding-bottom: 16px;
}

.pl-2 {
  padding-left: 16px;
}

.px-2 {
  padding-left: 16px;
  padding-right: 16px;
}

.py-2 {
  padding-top: 16px;
  padding-bottom: 16px;
}

.m-2 {
  margin: 16px;
}

.mt-2 {
  margin-top: 16px;
}

.mr-2 {
  margin-right: 16px;
}

.mb-2 {
  margin-bottom: 16px;
}

.ml-2 {
  margin-left: 16px;
}

.mx-2 {
  margin-left: 16px;
  margin-right: 16px;
}

.my-2 {
  margin-top: 16px;
  margin-bottom: 16px;
}

.p-3 {
  padding: 24px;
}

.pt-3 {
  padding-top: 24px;
}

.pr-3 {
  padding-right: 24px;
}

.pb-3 {
  padding-bottom: 24px;
}

.pl-3 {
  padding-left: 24px;
}

.px-3 {
  padding-left: 24px;
  padding-right: 24px;
}

.py-3 {
  padding-top: 24px;
  padding-bottom: 24px;
}

.m-3 {
  margin: 24px;
}

.mt-3 {
  margin-top: 24px;
}

.mr-3 {
  margin-right: 24px;
}

.mb-3 {
  margin-bottom: 24px;
}

.ml-3 {
  margin-left: 24px;
}

.mx-3 {
  margin-left: 24px;
  margin-right: 24px;
}

.my-3 {
  margin-top: 24px;
  margin-bottom: 24px;
}

.p-4 {
  padding: 32px;
}

.pt-4 {
  padding-top: 32px;
}

.pr-4 {
  padding-right: 32px;
}

.pb-4 {
  padding-bottom: 32px;
}

.pl-4 {
  padding-left: 32px;
}

.px-4 {
  padding-left: 32px;
  padding-right: 32px;
}

.py-4 {
  padding-top: 32px;
  padding-bottom: 32px;
}

.m-4 {
  margin: 32px;
}

.mt-4 {
  margin-top: 32px;
}

.mr-4 {
  margin-right: 32px;
}

.mb-4 {
  margin-bottom: 32px;
}

.ml-4 {
  margin-left: 32px;
}

.mx-4 {
  margin-left: 32px;
  margin-right: 32px;
}

.my-4 {
  margin-top: 32px;
  margin-bottom: 32px;
}

.p-5 {
  padding: 40px;
}

.pt-5 {
  padding-top: 40px;
}

.pr-5 {
  padding-right: 40px;
}

.pb-5 {
  padding-bottom: 40px;
}

.pl-5 {
  padding-left: 40px;
}

.px-5 {
  padding-left: 40px;
  padding-right: 40px;
}

.py-5 {
  padding-top: 40px;
  padding-bottom: 40px;
}

.m-5 {
  margin: 40px;
}

.mt-5 {
  margin-top: 40px;
}

.mr-5 {
  margin-right: 40px;
}

.mb-5 {
  margin-bottom: 40px;
}

.ml-5 {
  margin-left: 40px;
}

.mx-5 {
  margin-left: 40px;
  margin-right: 40px;
}

.my-5 {
  margin-top: 40px;
  margin-bottom: 40px;
}

.p-6 {
  padding: 48px;
}

.pt-6 {
  padding-top: 48px;
}

.pr-6 {
  padding-right: 48px;
}

.pb-6 {
  padding-bottom: 48px;
}

.pl-6 {
  padding-left: 48px;
}

.px-6 {
  padding-left: 48px;
  padding-right: 48px;
}

.py-6 {
  padding-top: 48px;
  padding-bottom: 48px;
}

.m-6 {
  margin: 48px;
}

.mt-6 {
  margin-top: 48px;
}

.mr-6 {
  margin-right: 48px;
}

.mb-6 {
  margin-bottom: 48px;
}

.ml-6 {
  margin-left: 48px;
}

.mx-6 {
  margin-left: 48px;
  margin-right: 48px;
}

.my-6 {
  margin-top: 48px;
  margin-bottom: 48px;
}

.p-7 {
  padding: 56px;
}

.pt-7 {
  padding-top: 56px;
}

.pr-7 {
  padding-right: 56px;
}

.pb-7 {
  padding-bottom: 56px;
}

.pl-7 {
  padding-left: 56px;
}

.px-7 {
  padding-left: 56px;
  padding-right: 56px;
}

.py-7 {
  padding-top: 56px;
  padding-bottom: 56px;
}

.m-7 {
  margin: 56px;
}

.mt-7 {
  margin-top: 56px;
}

.mr-7 {
  margin-right: 56px;
}

.mb-7 {
  margin-bottom: 56px;
}

.ml-7 {
  margin-left: 56px;
}

.mx-7 {
  margin-left: 56px;
  margin-right: 56px;
}

.my-7 {
  margin-top: 56px;
  margin-bottom: 56px;
}

.p-8 {
  padding: 64px;
}

.pt-8 {
  padding-top: 64px;
}

.pr-8 {
  padding-right: 64px;
}

.pb-8 {
  padding-bottom: 64px;
}

.pl-8 {
  padding-left: 64px;
}

.px-8 {
  padding-left: 64px;
  padding-right: 64px;
}

.py-8 {
  padding-top: 64px;
  padding-bottom: 64px;
}

.m-8 {
  margin: 64px;
}

.mt-8 {
  margin-top: 64px;
}

.mr-8 {
  margin-right: 64px;
}

.mb-8 {
  margin-bottom: 64px;
}

.ml-8 {
  margin-left: 64px;
}

.mx-8 {
  margin-left: 64px;
  margin-right: 64px;
}

.my-8 {
  margin-top: 64px;
  margin-bottom: 64px;
}

.p-9 {
  padding: 72px;
}

.pt-9 {
  padding-top: 72px;
}

.pr-9 {
  padding-right: 72px;
}

.pb-9 {
  padding-bottom: 72px;
}

.pl-9 {
  padding-left: 72px;
}

.px-9 {
  padding-left: 72px;
  padding-right: 72px;
}

.py-9 {
  padding-top: 72px;
  padding-bottom: 72px;
}

.m-9 {
  margin: 72px;
}

.mt-9 {
  margin-top: 72px;
}

.mr-9 {
  margin-right: 72px;
}

.mb-9 {
  margin-bottom: 72px;
}

.ml-9 {
  margin-left: 72px;
}

.mx-9 {
  margin-left: 72px;
  margin-right: 72px;
}

.my-9 {
  margin-top: 72px;
  margin-bottom: 72px;
}

.p-10 {
  padding: 80px;
}

.pt-10 {
  padding-top: 80px;
}

.pr-10 {
  padding-right: 80px;
}

.pb-10 {
  padding-bottom: 80px;
}

.pl-10 {
  padding-left: 80px;
}

.px-10 {
  padding-left: 80px;
  padding-right: 80px;
}

.py-10 {
  padding-top: 80px;
  padding-bottom: 80px;
}

.m-10 {
  margin: 80px;
}

.mt-10 {
  margin-top: 80px;
}

.mr-10 {
  margin-right: 80px;
}

.mb-10 {
  margin-bottom: 80px;
}

.ml-10 {
  margin-left: 80px;
}

.mx-10 {
  margin-left: 80px;
  margin-right: 80px;
}

.my-10 {
  margin-top: 80px;
  margin-bottom: 80px;
}

html {
  --mdc-outlined-text-field-focus-outline-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mdc-outlined-text-field-focus-label-text-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-option-selected-state-label-text-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-datepicker-toggle-active-state-icon-color: rgba(
    174,
    15,
    10,
    1
  ) !important;
  --mdc-filled-text-field-focus-active-indicator-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-sidenav-content-background-color: white !important;
}

/* You can add global styles to this file, and also import other style files */
/* Angular 15 adds grey background on mat form components */
/* below removes that background color */
/* Manipulate initial background color*/
.mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: transparent !important;
}

/*Manipulate background color on hover and focus*/
.mat-mdc-form-field-focus-overlay {
  background-color: transparent !important;
}

.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted {
  width: 0px;
  padding-left: 6px;
  padding-right: 6px;
}
.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted span {
  display: none;
}

/* Pagination menu */
.g-bubble-container {
  display: flex;
  gap: 4px;
  margin-left: 8px;
}

.g-bubble {
  background-color: rgb(245, 246, 249);
  border-radius: 4px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(34, 36, 40) !important;
  font-size: 1rem;
  cursor: pointer;
  transition: 0.3s;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-align: center;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
}

.g-bubble:hover {
  background-color: rgb(189, 188, 188);
  color: rgb(245, 246, 249);
}

.g-bubble__active {
  background-color: rgb(227, 6, 19);
  color: rgb(227, 227, 227) !important;
  box-shadow: 0px 5px 14px 0px rgba(0, 0, 0, 0.12), 0px 9px 10px 0px rgba(0, 0, 0, 0.14), 0px 5px 5px 0px rgba(0, 0, 0, 0.2);
}

mat-paginator {
  background: transparent !important;
}

.mat-mdc-paginator-range-actions {
  margin-right: 12px !important;
}

.mat-mdc-paginator-container {
  justify-content: center !important;
}

.mat-mdc-paginator-navigation-next,
.mat-mdc-paginator-navigation-previous {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: rgb(34, 36, 40) !important;
  padding: 0 !important;
  border-radius: 4px !important;
  width: 34px !important;
  height: 34px !important;
  background-color: rgb(245, 246, 249) !important;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
}

/* End of pagination menu */
body {
  margin: 0;
}

.snackbar {
  width: 50vw;
  margin: 10px 0px !important;
}
.snackbar .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
}
.snackbar .mdc-snackbar__label {
  color: black !important;
}
.snackbar .mat-icon {
  margin-right: 12px;
}

.snackbar-custom {
  width: 50vw;
  margin-top: 75px !important;
}

.snacbar-warning {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-warning .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid #e0ac08;
}
.snacbar-warning .mdc-snackbar__label {
  color: black !important;
}
.snacbar-warning .mat-icon {
  margin-right: 12px;
}

.snacbar-sucess {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-sucess .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid green;
}
.snacbar-sucess .mdc-snackbar__label {
  color: black !important;
}
.snacbar-sucess .mat-icon {
  margin-right: 12px;
}

.snacbar-error {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-error .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid red;
}
.snacbar-error .mdc-snackbar__label {
  color: black !important;
}
.snacbar-error .mat-icon {
  margin-right: 12px;
}

.flex {
  display: flex;
}

.mat-mdc-menu-panel {
  overflow: hidden !important;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .menu-header {
  font-size: 12px;
  padding: 1rem;
  padding-bottom: 0.25rem;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item {
  margin-left: 1rem;
  padding-left: 0;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item:first-of-type {
  margin-top: 0.75rem;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item:not(:last-child) {
  border-bottom: 1px solid rgb(189, 188, 188);
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 3000;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sort-icon-container {
  display: inline-flex;
  align-items: center;
}
.sort-icon-container mat-icon {
  height: 1rem;
  width: 1rem;
}

@media (max-width: 767px) {
  app-edit-contract .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    margin-right: 0 !important;
    width: 40% !important;
    height: 45px;
  }
}

.btn-primary.mat-mdc-unelevated-button.mat-unthemed {
  background: rgb(174, 15, 10);
  color: white;
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: none;
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    margin-right: 0 !important;
    width: 40%;
    height: 45px;
  }
}
.btn-primary.mat-mdc-unelevated-button.mat-unthemed[disabled] {
  background: rgb(189, 188, 188);
}

.btn-secondary.mat-mdc-unelevated-button.mat-unthemed {
  background: white;
  color: rgb(174, 15, 10);
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: 2px solid rgb(174, 15, 10);
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-secondary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    width: 100%;
    height: 45px;
  }
}
.btn-secondary.mat-mdc-unelevated-button.mat-unthemed[disabled] {
  background: rgb(189, 188, 188);
}

.btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {
  background: rgb(189, 188, 188);
  color: white;
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: none;
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    width: 100%;
    height: 45px;
  }
}

/* 
  IONIC components
*/
ion-item.no-padding {
  --padding-end: 0;
  --padding-start: 0;
}

ion-item.no-padding-full {
  --padding-end: 0;
  --padding-start: 0;
  --inner-padding-end: 0;
  --inner-padding-start: 0;
}

ion-checkbox {
  --checkbox-background-checked: rgba(174, 15, 10, 1);
  --border-color-checked: rgba(174, 15, 10, 1);
}

ion-input.custom-input {
  --border-color: rgba(135, 135, 135, 1);
  --padding-top: 5px;
  --highlight-color: rgba(135, 135, 135, 1);
}

ion-input.custom-input-user {
  --border-color: #EFEFEF;
  --padding-top: 5px;
  --highlight-color: rgba(135, 135, 135, 1);
}

ion-input.width-full {
  --border-color: #EFEFEF !important;
  --padding-top: 5px;
  --highlight-color: rgb(37, 19, 19);
}

.filter-panel {
  max-width: 100vw !important;
}

.date-select-modal-filter .mdc-text-field {
  height: 35px;
}
.date-select-modal-filter .mat-mdc-form-field-infix {
  height: 35px;
  min-height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.date-select-modal-filter .select-year .mat-mdc-text-field-wrapper {
  background-color: #f4f4f4;
  border: 1px solid rgb(189, 188, 188);
}
.date-select-modal-filter .mdc-notched-outline__leading {
  border: none !important;
}
.date-select-modal-filter .mdc-notched-outline__notch {
  border: none !important;
}
.date-select-modal-filter .mdc-notched-outline__trailing {
  border: none !important;
}

@media (min-width: 1025px) {
  .filter-panel {
    max-height: 33rem !important;
    min-width: 60vw;
  }
  .anotation-panel {
    max-width: 30rem !important;
    max-height: 30rem !important;
    min-width: 50vw;
  }
  .historic-panel {
    min-width: 49.5rem;
    min-height: 35.625rem;
    min-width: 50vw;
  }
  .segments-panel {
    width: 72vw;
    min-width: 760px;
    max-width: 1100px !important;
    max-height: 90vh !important;
  }
  .new-highway-modal-panel {
    min-width: 49.5rem;
    min-height: 23.625rem;
    min-width: 50vw;
  }
}
@media (max-width: 1024px) {
  .btn-actions {
    margin-right: 15px;
  }
  .filter-panel {
    min-height: 30rem;
    max-width: 100vw !important;
    min-width: 90vw;
  }
  .historic-panel {
    max-width: 49.5rem;
    min-width: 90vw !important;
  }
  .segments-panel {
    max-width: 90vw !important;
    min-width: 90vw !important;
    max-height: 90vh !important;
  }
  .new-highway-modal-panel {
    max-width: 49.5rem;
    min-width: 90vw !important;
  }
}
@media (max-width: 1024px) {
  .anotation-panel {
    width: 90%;
  }
}
.mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: transparent !important;
}

@media (max-width: 1024px) {
  .mat-mdc-form-field-label {
    font-size: 0.8rem;
    /* Tamanho de fonte para dispositivos móveis */
  }
}
.button_cad {
  background-color: rgb(174, 15, 10);
  padding: 0.5rem 2rem;
  border-radius: 0.5rem;
  color: #fff;
  font-style: none;
  text-decoration: none;
}
.button_cad mat-icon {
  color: #fff !important;
}

::ng-deep.mat-mdc-card-header-text {
  display: none !important;
}

.input-error {
  border: 1px solid red; /* Ajuste o estilo conforme necessário */
}

.card-mobile {
  min-height: 10rem;
  margin: 1rem auto;
  border: 1px solid #cdcdcd;
}
.card-mobile .mat-mdc-card-header {
  width: 90%;
  display: flex;
  margin: auto;
  justify-content: space-between;
  padding: 0rem;
}
.card-mobile .mat-mdc-card-header p {
  font-weight: bolder;
  font-size: 1.2rem;
  text-transform: uppercase;
}
.card-mobile .mat-mdc-card-header span,
.card-mobile .mat-mdc-card-header .subtitle {
  font-size: 1rem;
  font-weight: normal;
  color: #cdcdcd;
}
@media (max-width: 1024px) {
  .card-mobile .mat-mdc-card-header {
    width: 100%;
    margin: 0 16px;
  }
}
.card-mobile .mat-mdc-card-footer {
  margin: 1rem 0rem;
  border-top: 1px solid black;
  display: flex;
  align-items: center;
}
.card-mobile .mat-mdc-card-footer button {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.card-mobile .extension {
  font-weight: bold;
  color: rgb(174, 15, 10);
}
@media (max-width: 1024px) {
  .card-mobile .formatAnotation {
    padding: 0 16px;
  }
}
.card-mobile .content-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-mobile .content-status {
  width: 40%;
  align-items: center;
  display: flex;
  flex-direction: column;
}
.card-mobile .content-status p {
  font-weight: bold;
}

.card-mobile-empty {
  border: 1px solid #cdcdcd;
  display: flex;
  align-items: center;
  justify-content: center;
}

ion-button.more-filters-btn {
  --background: rgba(174, 15, 10, 1);
  --color: white;
  --border-radius: 10px;
  width: 100%;
  max-width: 15rem;
  text-transform: capitalize;
  font-size: 0.9rem;
  height: 100%;
  font-weight: 600;
  letter-spacing: 0.08em;
}

ion-item.fast-filters {
  padding: 0.25rem 0rem;
}

ion-chip.fast-filter-active-primary {
  background-color: rgb(40, 186, 98);
  color: white;
}

ion-chip.fast-filter-active-secondary {
  background-color: rgb(235, 68, 90);
  color: white;
}

ion-chip.fast-filter-active-primary-contract {
  color: #AE0F0A;
  border: 1px solid #AE0F0A;
  background: #E4ADB5;
}

ion-chip.fast-filter-active-secondary-contract {
  color: #AE0F0A;
  border: 1px solid #AE0F0A;
  background: #E4ADB5;
}

.more-filters-btn-row {
  justify-content: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.more-filters-btn-row button {
  margin: 5px;
}
@media (max-width: 767px) {
  .more-filters-btn-row button {
    margin: 5px 0;
  }
}

.status-container {
  display: flex;
  align-items: center;
}
.status-container .mat-icon {
  width: 1rem;
}
.status-container .status-icon {
  font-size: 8px;
  align-content: center;
  text-align: center;
}
.status-container .active {
  color: rgb(40, 186, 98);
}
.status-container .inactive {
  color: rgb(235, 68, 90);
}

ion-textarea,
ion-input {
  --border-color: rgba(87, 87, 86, 1);
  --padding-top: 5px !important;
  --highlight-color: rgba(135, 135, 135, 1);
  --highlight-color-focused: rgba(135, 135, 135, 1) !important;
  --highlight-color-valid: rgba(135, 135, 135, 1) !important;
  --highlight-color-invalid: rgba(174, 15, 10, 1) !important;
}

ion-alert.custom-alert {
  --backdrop-opacity: 0.7;
}

ion-list.filtered-list {
  display: flex;
  flex-wrap: wrap;
}
ion-list.filtered-list span {
  padding: 0.75rem 0;
  margin: 0 0.75rem;
  border-bottom: 1px solid rgb(189, 188, 188);
  width: 100%;
}

ion-item.no-padding {
  --padding-end: 0;
  --padding-start: 0;
}

ion-toast.snackbar-toast {
  --box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);
  --width: fit-content;
  --border-radius: 0.75rem;
  --white-space: pre-line;
}

ion-toast.snackbar-toast::part(container) {
  background: #fff;
  color: rgb(34, 36, 40);
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 0.75rem;
}

ion-toast.snackbar-toast.toast-success::part(container) {
  border: 1px solid rgb(45, 211, 111);
}
ion-toast.snackbar-toast.toast-success::part(icon) {
  color: rgb(45, 211, 111);
  font-size: 1.25rem;
}

ion-toast.snackbar-toast.toast-error::part(container) {
  border: 1px solid rgb(235, 68, 90);
}
ion-toast.snackbar-toast.toast-error::part(icon) {
  color: rgb(235, 68, 90);
  font-size: 1.25rem;
}

ion-toast.snackbar-toast.toast-right {
  --start: right;
  --box-shadow: none;
  --background: none;
}
ion-toast.snackbar-toast.toast-right::part(container) {
  transform: translateY(72px) !important;
  box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);
}

::ng-deep.mat-tab-label {
  min-width: 25px !important;
  padding: 5px;
  background-color: transparent;
  color: red !important;
  font-weight: 700;
}

/* Styles for the active tab label */
::ng-deep.mat-tab-label.mat-tab-label-active {
  min-width: 25px !important;
  padding: 5px;
  background-color: transparent;
  color: red !important;
  font-weight: 700;
}

::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab .mdc-tab-indicator__content--underline {
  border-color: #2b2b2b;
}

::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: #2b2b2b;
}

.mat-mdc-paginator-navigation-next, .mat-mdc-paginator-navigation-previous {
  box-shadow: none !important;
}

.g-bubble {
  box-shadow: none !important;
}

app-modal-historic-segment {
  display: block;
  width: 100%;
  height: 45em;
}

.column-flex {
  display: flex;
  flex-flow: column;
}

.master-icon {
  background-color: rgb(255, 202, 34);
  color: rgb(34, 36, 40);
  border-radius: 10px;
  align-self: flex-start;
  font-size: 10px;
  padding: 0px 9px;
  margin: 6px 0;
  line-height: 17px;
  font-weight: 600;
}
.master-icon.center-horizontal {
  place-self: center;
}

ion-popover {
  --min-width: 375px;
  --max-width: 500px;
}

.custom-tooltip-menu {
  padding: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
.custom-tooltip-menu .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) {
  background: none;
}
.custom-tooltip-menu .mdc-evolution-chip__text-label {
  color: #c00;
}

.custom-tooltip-menu .filter-title {
  font-size: 12px;
  font-weight: bold;
  color: #333;
  display: block;
  margin-bottom: 4px;
  border-bottom: 1px solid grey;
}

.custom-tooltip-menu .tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.custom-tooltip-menu mat-chip {
  border: 1px solid #c00;
  height: 20px;
}

.custom-tooltip-menu mat-chip mat-icon {
  color: #c00 !important;
  cursor: pointer;
  font-size: 14px !important;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 0px !important;
}

.custom-tooltip-menu mat-chip .mdc-evolution-chip__text-label {
  color: #c00 !important;
  cursor: pointer;
  font-size: 12px !important;
  opacity: 1;
}

::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab .mdc-tab-indicator__content--underline {
  border: 1px solid #c00 !important;
}

::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: #c00 !important;
}

ion-toggle {
  --handle-background-checked: rgba(174, 15, 10, 1);
  --track-background-checked: rgba(174, 15, 10, 0.38);
}

app-list-contracts thead {
  background: #F4F4F4 !important;
}

app-table-default thead {
  background: #F4F4F4 !important;
}

.mat-expansion-panel-body {
  padding: 0px !important;
}

.mat-mdc-paginator-range-actions {
  overflow-wrap: anywhere !important;
  flex-grow: 1;
  justify-content: center !important;
  position: relative !important;
}

.mat-mdc-paginator-container:has(.mat-mdc-paginator-page-size) .mat-mdc-paginator-range-actions .mat-mdc-paginator-range-label {
  position: absolute !important;
  left: 0 !important;
}

.mat-mdc-tab {
  background-color: #F4F4F4 !important;
}

.mdc-tab--active {
  background-color: white !important;
}

@media (max-width: 1025px) {
  #paginator {
    width: 100%;
  }
}

ion-icon.search-icon-absolute {
  position: absolute;
  left: 16px;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 3;
}

ion-input.search-input label.input-wrapper {
  --padding-start: 55px;
}
.mat-mdc-icon-button[disabled] {
  cursor: default;
  pointer-events: auto;
  opacity: 0.38;
}

.mat-mdc-unelevated-button[disabled] {
  cursor: default;
  pointer-events: auto;
  opacity: 0.38;
}

.item-inner {
  padding-right: 0 !important;
}

@media (max-width: 496px) {
  .mat-mdc-paginator-page-size-label {
    display: none !important;
  }
}

.comentarios .mdc-text-field--outlined {
  --mdc-outlined-text-field-outline-width: 1px;
  --mdc-outlined-text-field-outline-color: #EFEFEF; /* Borda normal */
  --mdc-outlined-text-field-focus-outline-color: #EFEFEF; /* Borda ao focar */
  --mdc-outlined-text-field-container-shape: 4px;
}

.g-0 {
  gap: 0 !important;
}

.g-1 {
  gap: 0.25rem !important;
}

.g-2 {
  gap: 0.5rem !important;
}

.g-3 {
  gap: 1rem !important;
}

.g-4 {
  gap: 1.5rem !important;
}

.g-5 {
  gap: 3rem !important;
}

.gx-0 {
  column-gap: 0 !important;
}

.gx-1 {
  column-gap: 0.25rem !important;
}

.gx-2 {
  column-gap: 0.5rem !important;
}

.gx-3 {
  column-gap: 1rem !important;
}

.gx-4 {
  column-gap: 1.5rem !important;
}

.gx-5 {
  column-gap: 3rem !important;
}

.gy-0 {
  row-gap: 0 !important;
}

.gy-1 {
  row-gap: 0.25rem !important;
}

.gy-2 {
  row-gap: 0.5rem !important;
}

.gy-3 {
  row-gap: 1rem !important;
}

.gy-4 {
  row-gap: 1.5rem !important;
}

.gy-5 {
  row-gap: 3rem !important;
}

.col {
  flex: 1 0 0%;
  max-width: 100%;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.col-1 {
  flex: 0 0 6.333333%;
  max-width: 6.333333%;
}

.col-2 {
  flex: 0 0 14.666667%;
  max-width: 14.666667%;
}

.col-3 {
  flex: 0 0 23%;
  max-width: 23%;
}

.col-4 {
  flex: 0 0 31.333333%;
  max-width: 31.333333%;
}

.col-5 {
  flex: 0 0 39.666667%;
  max-width: 39.666667%;
}

.col-6 {
  flex: 0 0 48%;
  max-width: 48%;
}

.col-7 {
  flex: 0 0 56.333333%;
  max-width: 56.333333%;
}

.col-8 {
  flex: 0 0 64.666667%;
  max-width: 64.666667%;
}

.col-9 {
  flex: 0 0 73%;
  max-width: 73%;
}

.col-10 {
  flex: 0 0 81.333333%;
  max-width: 81.333333%;
}

.col-11 {
  flex: 0 0 89.666667%;
  max-width: 89.666667%;
}

.col-12 {
  flex: 0 0 98%;
  max-width: 98%;
}

/* Colunas responsivas */
@media (min-width: 576px) { /* sm */
  .col-sm-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-sm-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-sm-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-sm-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-sm-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-sm-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-sm-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-sm-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-sm-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-sm-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-sm-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-sm-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 768px) { /* md */
  .col-md-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-md-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-md-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-md-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-md-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-md-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-md-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-md-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-md-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-md-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-md-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media (min-width: 992px) { /* lg */
  .col-lg-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-lg-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-lg-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-lg-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-lg-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-lg-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-lg-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-lg-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-lg-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-lg-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-lg-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-lg-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 1200px) { /* xl */
  .col-xl-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-xl-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-xl-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-xl-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-xl-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-xl-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-xl-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-xl-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-xl-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-xl-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-xl-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-xl-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 1400px) { /* xxl */
  .col-xxl-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-xxl-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-xxl-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-xxl-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-xxl-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-xxl-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-xxl-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-xxl-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-xxl-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-xxl-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-xxl-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-xxl-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
.ampliacao-panel {
  max-width: 60vw !important;
}

.popover-content {
  max-height: 150px;
}

app-form-projetos thead tr th {
  font-family: "Barlow", sans-serif !important;
  font-weight: 500 !important;
  font-size: 18px !important;
  line-height: 100% !important;
}

app-form-projetos .mat-mdc-header-cell {
  border: none !important;
}

app-form-projetos .mat-mdc-form-field-subscript-wrapper {
  display: none;
}

.mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #AE0F0A !important;
  background-color: #AE0F0A !important;
}

ion-button,
ion-input {
  pointer-events: auto;
}

.select-wrapper .select-field {
  position: relative;
  width: 100%;
}
.select-wrapper .filtered-list {
  max-height: 10rem;
  overflow-y: auto;
  cursor: pointer;
  position: absolute;
  z-index: 11;
  width: 100%;
  box-shadow: 0px 7px 5px 1px rgba(0, 0, 0, 0.12), 0px 4px 4px 3px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
}
.select-wrapper .no-results {
  font-style: italic;
}
.select-wrapper ion-icon {
  color: rgb(87, 87, 86);
}

.inner-padding {
  display: flex;
  justify-content: center;
}
.inner-padding .select-wrapper {
  width: calc(100% - 2rem);
}

ion-input {
  width: 100%;
  background-color: white;
}

.mobile {
  width: 270px;
}

.desktop {
  width: 370px;
}

.width-full {
  width: 100%;
}

.clear-button {
  position: absolute;
  right: 8px;
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/select-search-input/select-search-input.component.scss","webpack://./node_modules/@angular/material/core/ripple/_ripple.scss","webpack://./node_modules/@angular/cdk/a11y/_index.scss","webpack://./node_modules/@angular/cdk/overlay/_index.scss","webpack://./node_modules/@angular/cdk/text-field/_index.scss","webpack://./node_modules/@angular/material/core/focus-indicators/_private.scss","webpack://./node_modules/@angular/material/core/style/_layout-common.scss","webpack://./src/theme/variables.scss","webpack://./src/theme/typography.scss","webpack://./src/theme/spacing.scss","webpack://./src/styles.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACKd;EACE,gBAAA;EAIA,kBAAA;ADHJ;ACUI;EACE,wBAAA;ADRN;;ACYE;EACE,iBAAA;ADTJ;;ACYE;EACE,kBAAA;EACA,kBAAA;EACA,oBAAA;EAEA,6DAAA;EAIA,2BAAA;ADbJ;AE4BI;EDXE,aAAA;ADdN;;AEtBE;EACE,SAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EAIA,mBAAA;EAGA,UAAA;EAGA,wBAAA;EACA,qBAAA;EAMA,OAAA;AFaJ;AEXI;EACE,UAAA;EACA,QAAA;AFaN;;AG7BE;EAEE,oBAAA;EAGA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AH6BJ;;AGzBE;EACE,eAAA;EACA,aA3BwB;AHuD5B;AG1BI;EAGE,aAAA;AH0BN;;AGlBE;EACE,aAAA;EACA,kBAAA;EACA,aA1Cc;AH+DlB;;AGjBE;EAGE,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,aApDc;EAwDd,aAAA;EACA,eAAA;EACA,gBAAA;AHeJ;;AGZE;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EAEA,aApEuB;EAqEvB,oBAAA;EACA,wCAAA;EACA,0DAAA;EACA,UAAA;AHaJ;AGXI;EACE,UAAA;AHaN;AGRM;EAGE,YAAA;AHQR;;AGHE;EACE,+BAtFqB;AH4FzB;;AGHE;EAEE,qDAAA;EACA,kBAAA;EACA,UAAA;AHKJ;AGCI;EACE,UAAA;EACA,mBAAA;AHCN;;AGGE;EACE,gBAAA;AHAJ;;AGKE;EACE,kBAAA;EACA,aArHc;EA0Hd,aAAA;EAIA,sBAAA;EAGA,cAAA;EACA,eAAA;AHXJ;;AGeE;EACE,eAAA;EAKA,WAAA;EAKA,kBAAA;AHpBJ;;AI7HE;EACE,YAAA;AJgIJ;;AI1HE;EAyCA,yBAAA;EACA,kCAAA;EAxCE,uBAAA;EACA,2BAAA;AJ8HJ;;AIrHE;EA6BA,yBAAA;EACA,kCAAA;EA5BE,oBAAA;AJyHJ;;AI/GE,2CAAA,IAAA,EAAA;AACA,yCAAA,IAAA,EAAA;AAEA;EAEE,+CAAA;AJgHJ;;AI7GE;EAEE,6CAAA;AJ+GJ;;AK9IE;EACE,kBAAA;ALiJJ;AK/II;ECfF,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EDaI,sBAAA;EACA,oBAAA;EACA,iDAAA;EACA,wJAAA;EAYA,4DAAA;AL0IN;AKlII;EACE,WAAA;ALoIN;;AEzFM;EG7BA,oCAAA;AL0HN;;AKrKE;EACE,kBAAA;ALwKJ;AKtKI;ECfF,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EDaI,sBAAA;EACA,oBAAA;EACA,qDAAA;EACA,oKAAA;EAYA,gEAAA;ALiKN;AKzJI;EACE,WAAA;AL2JN;;AEhHM;EG7BA,wCAAA;ALiJN;;AO1MA;;;;;CAAA;ACEA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ARiNF;;AQ9MA;;;;;;EAME,qCAAA;EACA,gBAAA;ARiNF;;AQ9MA;EACE,eAAA;EACA,iBAAA;ARiNF;;AQ9MA;EACE,eAAA;EACA,iBAAA;ARiNF;;AQ9MA;EACE,eAAA;EACA,iBAAA;ARiNF;;AQ9MA;EACE,eAAA;EACA,iBAAA;ARiNF;;AQ9MA;EACE,eAAA;EACA,iBAAA;ARiNF;;AQ9MA;EACE,eAAA;EACA,iBAAA;ARiNF;;AQ9MA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;ARiNF;;AQ9MA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;ARiNF;;AQ9MA;EACE,gBAAA;EACA,eAAA;ARiNF;;AOnRA;;;;;CAAA;AEeE;EACE,YAAA;AT6QJ;;AS3QE;EACE,gBAAA;AT8QJ;;AS5QE;EACE,kBAAA;AT+QJ;;AS7QE;EACE,mBAAA;ATgRJ;;AS9QE;EACE,iBAAA;ATiRJ;;AS/QE;EACE,iBAAA;EACA,kBAAA;ATkRJ;;AShRE;EACE,gBAAA;EACA,mBAAA;ATmRJ;;AShRE;EACE,WAAA;ATmRJ;;ASjRE;EACE,eAAA;AToRJ;;ASlRE;EACE,iBAAA;ATqRJ;;ASnRE;EACE,kBAAA;ATsRJ;;ASpRE;EACE,gBAAA;ATuRJ;;ASrRE;EACE,gBAAA;EACA,iBAAA;ATwRJ;;AStRE;EACE,eAAA;EACA,kBAAA;ATyRJ;;AStUE;EACE,YAAA;ATyUJ;;ASvUE;EACE,gBAAA;AT0UJ;;ASxUE;EACE,kBAAA;AT2UJ;;ASzUE;EACE,mBAAA;AT4UJ;;AS1UE;EACE,iBAAA;AT6UJ;;AS3UE;EACE,iBAAA;EACA,kBAAA;AT8UJ;;AS5UE;EACE,gBAAA;EACA,mBAAA;AT+UJ;;AS5UE;EACE,WAAA;AT+UJ;;AS7UE;EACE,eAAA;ATgVJ;;AS9UE;EACE,iBAAA;ATiVJ;;AS/UE;EACE,kBAAA;ATkVJ;;AShVE;EACE,gBAAA;ATmVJ;;ASjVE;EACE,gBAAA;EACA,iBAAA;AToVJ;;ASlVE;EACE,eAAA;EACA,kBAAA;ATqVJ;;ASlYE;EACE,aAAA;ATqYJ;;ASnYE;EACE,iBAAA;ATsYJ;;ASpYE;EACE,mBAAA;ATuYJ;;ASrYE;EACE,oBAAA;ATwYJ;;AStYE;EACE,kBAAA;ATyYJ;;ASvYE;EACE,kBAAA;EACA,mBAAA;AT0YJ;;ASxYE;EACE,iBAAA;EACA,oBAAA;AT2YJ;;ASxYE;EACE,YAAA;AT2YJ;;ASzYE;EACE,gBAAA;AT4YJ;;AS1YE;EACE,kBAAA;AT6YJ;;AS3YE;EACE,mBAAA;AT8YJ;;AS5YE;EACE,iBAAA;AT+YJ;;AS7YE;EACE,iBAAA;EACA,kBAAA;ATgZJ;;AS9YE;EACE,gBAAA;EACA,mBAAA;ATiZJ;;AS9bE;EACE,aAAA;ATicJ;;AS/bE;EACE,iBAAA;ATkcJ;;AShcE;EACE,mBAAA;ATmcJ;;ASjcE;EACE,oBAAA;ATocJ;;ASlcE;EACE,kBAAA;ATqcJ;;ASncE;EACE,kBAAA;EACA,mBAAA;ATscJ;;ASpcE;EACE,iBAAA;EACA,oBAAA;ATucJ;;ASpcE;EACE,YAAA;ATucJ;;ASrcE;EACE,gBAAA;ATwcJ;;AStcE;EACE,kBAAA;ATycJ;;ASvcE;EACE,mBAAA;AT0cJ;;ASxcE;EACE,iBAAA;AT2cJ;;ASzcE;EACE,iBAAA;EACA,kBAAA;AT4cJ;;AS1cE;EACE,gBAAA;EACA,mBAAA;AT6cJ;;AS1fE;EACE,aAAA;AT6fJ;;AS3fE;EACE,iBAAA;AT8fJ;;AS5fE;EACE,mBAAA;AT+fJ;;AS7fE;EACE,oBAAA;ATggBJ;;AS9fE;EACE,kBAAA;ATigBJ;;AS/fE;EACE,kBAAA;EACA,mBAAA;ATkgBJ;;AShgBE;EACE,iBAAA;EACA,oBAAA;ATmgBJ;;AShgBE;EACE,YAAA;ATmgBJ;;ASjgBE;EACE,gBAAA;ATogBJ;;ASlgBE;EACE,kBAAA;ATqgBJ;;ASngBE;EACE,mBAAA;ATsgBJ;;ASpgBE;EACE,iBAAA;ATugBJ;;ASrgBE;EACE,iBAAA;EACA,kBAAA;ATwgBJ;;AStgBE;EACE,gBAAA;EACA,mBAAA;ATygBJ;;AStjBE;EACE,aAAA;ATyjBJ;;ASvjBE;EACE,iBAAA;AT0jBJ;;ASxjBE;EACE,mBAAA;AT2jBJ;;ASzjBE;EACE,oBAAA;AT4jBJ;;AS1jBE;EACE,kBAAA;AT6jBJ;;AS3jBE;EACE,kBAAA;EACA,mBAAA;AT8jBJ;;AS5jBE;EACE,iBAAA;EACA,oBAAA;AT+jBJ;;AS5jBE;EACE,YAAA;AT+jBJ;;AS7jBE;EACE,gBAAA;ATgkBJ;;AS9jBE;EACE,kBAAA;ATikBJ;;AS/jBE;EACE,mBAAA;ATkkBJ;;AShkBE;EACE,iBAAA;ATmkBJ;;ASjkBE;EACE,iBAAA;EACA,kBAAA;ATokBJ;;ASlkBE;EACE,gBAAA;EACA,mBAAA;ATqkBJ;;ASlnBE;EACE,aAAA;ATqnBJ;;ASnnBE;EACE,iBAAA;ATsnBJ;;ASpnBE;EACE,mBAAA;ATunBJ;;ASrnBE;EACE,oBAAA;ATwnBJ;;AStnBE;EACE,kBAAA;ATynBJ;;ASvnBE;EACE,kBAAA;EACA,mBAAA;AT0nBJ;;ASxnBE;EACE,iBAAA;EACA,oBAAA;AT2nBJ;;ASxnBE;EACE,YAAA;AT2nBJ;;ASznBE;EACE,gBAAA;AT4nBJ;;AS1nBE;EACE,kBAAA;AT6nBJ;;AS3nBE;EACE,mBAAA;AT8nBJ;;AS5nBE;EACE,iBAAA;AT+nBJ;;AS7nBE;EACE,iBAAA;EACA,kBAAA;ATgoBJ;;AS9nBE;EACE,gBAAA;EACA,mBAAA;ATioBJ;;AS9qBE;EACE,aAAA;ATirBJ;;AS/qBE;EACE,iBAAA;ATkrBJ;;AShrBE;EACE,mBAAA;ATmrBJ;;ASjrBE;EACE,oBAAA;ATorBJ;;ASlrBE;EACE,kBAAA;ATqrBJ;;ASnrBE;EACE,kBAAA;EACA,mBAAA;ATsrBJ;;ASprBE;EACE,iBAAA;EACA,oBAAA;ATurBJ;;ASprBE;EACE,YAAA;ATurBJ;;ASrrBE;EACE,gBAAA;ATwrBJ;;AStrBE;EACE,kBAAA;ATyrBJ;;ASvrBE;EACE,mBAAA;AT0rBJ;;ASxrBE;EACE,iBAAA;AT2rBJ;;ASzrBE;EACE,iBAAA;EACA,kBAAA;AT4rBJ;;AS1rBE;EACE,gBAAA;EACA,mBAAA;AT6rBJ;;AS1uBE;EACE,aAAA;AT6uBJ;;AS3uBE;EACE,iBAAA;AT8uBJ;;AS5uBE;EACE,mBAAA;AT+uBJ;;AS7uBE;EACE,oBAAA;ATgvBJ;;AS9uBE;EACE,kBAAA;ATivBJ;;AS/uBE;EACE,kBAAA;EACA,mBAAA;ATkvBJ;;AShvBE;EACE,iBAAA;EACA,oBAAA;ATmvBJ;;AShvBE;EACE,YAAA;ATmvBJ;;ASjvBE;EACE,gBAAA;ATovBJ;;ASlvBE;EACE,kBAAA;ATqvBJ;;ASnvBE;EACE,mBAAA;ATsvBJ;;ASpvBE;EACE,iBAAA;ATuvBJ;;ASrvBE;EACE,iBAAA;EACA,kBAAA;ATwvBJ;;AStvBE;EACE,gBAAA;EACA,mBAAA;ATyvBJ;;AStyBE;EACE,aAAA;ATyyBJ;;ASvyBE;EACE,iBAAA;AT0yBJ;;ASxyBE;EACE,mBAAA;AT2yBJ;;ASzyBE;EACE,oBAAA;AT4yBJ;;AS1yBE;EACE,kBAAA;AT6yBJ;;AS3yBE;EACE,kBAAA;EACA,mBAAA;AT8yBJ;;AS5yBE;EACE,iBAAA;EACA,oBAAA;AT+yBJ;;AS5yBE;EACE,YAAA;AT+yBJ;;AS7yBE;EACE,gBAAA;ATgzBJ;;AS9yBE;EACE,kBAAA;ATizBJ;;AS/yBE;EACE,mBAAA;ATkzBJ;;AShzBE;EACE,iBAAA;ATmzBJ;;ASjzBE;EACE,iBAAA;EACA,kBAAA;ATozBJ;;ASlzBE;EACE,gBAAA;EACA,mBAAA;ATqzBJ;;ASl2BE;EACE,aAAA;ATq2BJ;;ASn2BE;EACE,iBAAA;ATs2BJ;;ASp2BE;EACE,mBAAA;ATu2BJ;;ASr2BE;EACE,oBAAA;ATw2BJ;;ASt2BE;EACE,kBAAA;ATy2BJ;;ASv2BE;EACE,kBAAA;EACA,mBAAA;AT02BJ;;ASx2BE;EACE,iBAAA;EACA,oBAAA;AT22BJ;;ASx2BE;EACE,YAAA;AT22BJ;;ASz2BE;EACE,gBAAA;AT42BJ;;AS12BE;EACE,kBAAA;AT62BJ;;AS32BE;EACE,mBAAA;AT82BJ;;AS52BE;EACE,iBAAA;AT+2BJ;;AS72BE;EACE,iBAAA;EACA,kBAAA;ATg3BJ;;AS92BE;EACE,gBAAA;EACA,mBAAA;ATi3BJ;;AUr6BA;EACE;;;;;cAAA;EAMA;;;;;cAAA;EAOA;;;;;cAAA;EAOA;;;;;cAAA;EAOA;;;;;cAAA;EAOA,wDAAA;AVo6BF;;AUj6BA,8EAAA;AACA,2DAAA;AACA,wCAAA;AACA,uCAAA;AACA;EACE,wCAAA;AVo6BF;;AUj6BA,iDAAA;AACA;EACE,wCAAA;AVo6BF;;AUj6BA;EACE,UAAA;EACA,iBAAA;EACA,kBAAA;AVo6BF;AUl6BE;EACE,aAAA;AVo6BJ;;AUh6BA,oBAAA;AACA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;AVm6BF;;AUh6BA;EACE,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,wHAAA;AVm6BF;;AU/5BA;EACE,oCAAA;EACA,yBAAA;AVk6BF;;AU/5BA;EACE,iCAAA;EACA,oCAAA;EACA,0HAAA;AVk6BF;;AU95BA;EACE,kCAAA;AVi6BF;;AU95BA;EACE,6BAAA;AVi6BF;;AU95BA;EACE,kCAAA;AVi6BF;;AU95BA;;EAEE,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,iCAAA;EACA,qBAAA;EACA,6BAAA;EACA,sBAAA;EACA,uBAAA;EACA,+CAAA;EACA,wHAAA;AVi6BF;;AU75BA,2BAAA;AAEA;EACE,SAAA;AV+5BF;;AU55BA;EACE,WAAA;EACA,2BAAA;AV+5BF;AU75BE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;AV+5BJ;AU55BE;EACE,uBAAA;AV85BJ;AU35BE;EACE,kBAAA;AV65BJ;;AUz5BA;EACE,WAAA;EACA,2BAAA;AV45BF;;AUz5BA;EACE,WAAA;EACA,gBAAA;AV45BF;AU15BE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,yBAAA;AV45BJ;AUz5BE;EACE,uBAAA;AV25BJ;AUx5BE;EACE,kBAAA;AV05BJ;;AUt5BA;EACE,WAAA;EACA,gBAAA;AVy5BF;AUv5BE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,uBAAA;AVy5BJ;AUt5BE;EACE,uBAAA;AVw5BJ;AUr5BE;EACE,kBAAA;AVu5BJ;;AUn5BA;EACE,WAAA;EACA,gBAAA;AVs5BF;AUp5BE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,qBAAA;AVs5BJ;AUn5BE;EACE,uBAAA;AVq5BJ;AUl5BE;EACE,kBAAA;AVo5BJ;;AUh5BA;EACE,aAAA;AVm5BF;;AUh5BA;EACE,2BAAA;AVm5BF;AUh5BI;EACE,eAAA;EACA,aAAA;EACA,uBAAA;AVk5BN;AU/4BI;EACE,iBAAA;EACA,eAAA;AVi5BN;AU94BI;EACE,mBAAA;AVg5BN;AU74BI;EACE,2CAAA;AV+4BN;;AU14BA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AV64BF;;AU14BA;EACE,oBAAA;EACA,mBAAA;AV64BF;AU34BE;EACE,YAAA;EACA,WAAA;AV64BJ;;AUx4BI;EADF;IAEI,gBAAA;IACA,0BAAA;IACA,qBAAA;IACA,YAAA;EV44BJ;AACF;;AUz4BA;EACE,4BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AV44BF;AU14BE;EAXF;IAYI,gBAAA;IACA,0BAAA;IACA,UAAA;IACA,YAAA;EV64BF;AACF;AU34BE;EACE,8BAAA;AV64BJ;;AUz4BA;EACE,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AV44BF;AU14BE;EAXF;IAYI,gBAAA;IACA,WAAA;IACA,YAAA;EV64BF;AACF;AU34BE;EACE,8BAAA;AV64BJ;;AUz4BA;EACE,8BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AV44BF;AU14BE;EAXF;IAYI,gBAAA;IACA,WAAA;IACA,YAAA;EV64BF;AACF;;AU14BA;;CAAA;AAGA;EACE,gBAAA;EACA,kBAAA;AV64BF;;AU14BA;EACE,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;AV64BF;;AU34BA;EACE,mDAAA;EACA,4CAAA;AV84BF;;AU34BA;EACE,sCAAA;EACA,kBAAA;EACA,yCAAA;AV84BF;;AU54BA;EACE,uBAAA;EACA,kBAAA;EACA,yCAAA;AV+4BF;;AU74BA;EACE,kCAAA;EACA,kBAAA;EACA,kCAAA;AVg5BF;;AU94BA;EACE,2BAAA;AVi5BF;;AU94BE;EACE,YAAA;AVi5BJ;AU/4BE;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,8BAAA;AVi5BJ;AU94BI;EACE,yBAAA;EACA,oCAAA;AVg5BN;AU54BE;EACE,uBAAA;AV84BJ;AU54BE;EACE,uBAAA;AV84BJ;AU54BE;EACE,uBAAA;AV84BJ;;AU14BA;EACE;IACE,4BAAA;IACA,eAAA;EV64BF;EU14BA;IACE,2BAAA;IACA,4BAAA;IACA,eAAA;EV44BF;EUz4BA;IACE,kBAAA;IACA,qBAAA;IACA,eAAA;EV24BF;EUz4BA;IACE,WAAA;IACA,gBAAA;IACA,4BAAA;IACA,2BAAA;EV24BF;EUz4BA;IACE,kBAAA;IACA,qBAAA;IACA,eAAA;EV24BF;AACF;AUx4BA;EACE;IACE,kBAAA;EV04BF;EUx4BA;IACE,iBAAA;IACA,2BAAA;IACA,eAAA;EV04BF;EUv4BA;IACE,kBAAA;IACA,0BAAA;EVy4BF;EUv4BA;IACE,0BAAA;IACA,0BAAA;IACA,2BAAA;EVy4BF;EUv4BE;IACF,kBAAA;IACE,0BAAA;EVy4BF;AACF;AUt4BA;EACE;IACE,UAAA;EVw4BF;AACF;AUr4BA;EACE,wCAAA;AVu4BF;;AUp4BA;EACE;IACE,iBAAA;IACA,8CAAA;EVu4BF;AACF;AUp4BA;EACE,kCAAA;EACA,oBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;AVs4BF;AUp4BE;EACE,sBAAA;AVs4BJ;;AUl4BA;EACE,wBAAA;AVq4BF;;AUn4BA;EACE,qBAAA,EAAA,wCAAA;AVs4BF;;AUp4BA;EACE,iBAAA;EACA,iBAAA;EACA,yBAAA;AVu4BF;AUr4BE;EACE,UAAA;EACA,aAAA;EACA,YAAA;EAEA,8BAAA;EACA,aAAA;AVs4BJ;AUp4BI;EACE,mBAAA;EACA,iBAAA;EACA,yBAAA;AVs4BN;AUn4BI;;EAEE,eAAA;EACA,mBAAA;EACA,cAAA;AVq4BN;AUn4BI;EApBF;IAqBI,WAAA;IACA,cAAA;EVs4BJ;AACF;AUn4BE;EACE,iBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;AVq4BJ;AUn4BI;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AVq4BN;AUj4BE;EACE,iBAAA;EACA,uBAAA;AVm4BJ;AUh4BI;EADF;IAEI,eAAA;EVm4BJ;AACF;AUh4BE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AVk4BJ;AU/3BE;EACE,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AVi4BJ;AU/3BI;EACE,iBAAA;AVi4BN;;AU53BA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AV+3BF;;AU53BA;EACE,kCAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;AV+3BF;;AU53BA;EACE,qBAAA;AV+3BF;;AU53BA;EACE,kCAAA;EACA,YAAA;AV+3BF;;AU53BA;EACE,kCAAA;EACA,YAAA;AV+3BF;;AU73BA;EAEE,cAAA;EACA,yBAAA;EACA,mBAAA;AV+3BF;;AU33BA;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;AV83BF;;AU53BA;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;AV+3BF;AU73BE;EACE,WAAA;AV+3BJ;AU53BE;EACE;IACE,aAAA;EV83BJ;AACF;;AU13BA;EACE,aAAA;EACA,mBAAA;AV63BF;AU33BE;EACE,WAAA;AV63BJ;AU13BE;EACE,cAAA;EACA,qBAAA;EACA,kBAAA;AV43BJ;AUz3BE;EACE,uBAAA;AV23BJ;AUx3BE;EACE,uBAAA;AV03BJ;;AUt3BA;;EAEE,mCAAA;EACA,6BAAA;EACA,yCAAA;EACA,4DAAA;EACA,0DAAA;EACA,0DAAA;AVy3BF;;AUt3BA;EACE,uBAAA;AVy3BF;;AUt3BA;EACE,aAAA;EACA,eAAA;AVy3BF;AUv3BE;EACE,kBAAA;EACA,iBAAA;EACA,2CAAA;EACA,WAAA;AVy3BJ;;AUr3BA;EACE,gBAAA;EACA,kBAAA;AVw3BF;;AUp3BA;EACE,iDAAA;EACA,oBAAA;EACA,wBAAA;EACA,uBAAA;AVu3BF;;AUn3BE;EACE,gBAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,sBAAA;AVs3BJ;;AUj3BE;EACE,mCAAA;AVo3BJ;AUj3BE;EACE,wBAAA;EACA,kBAAA;AVm3BJ;;AU92BE;EACE,kCAAA;AVi3BJ;AU92BE;EACE,uBAAA;EACA,kBAAA;AVg3BJ;;AU52BA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;AV+2BF;AU72BE;EACE,sCAAA;EACA,+CAAA;AV+2BJ;;AU32BA;EACE,0BAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;AV82BF;;AU32BA,oCAAA;AACA;EACE,0BAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;AV82BF;;AU32BA;EAEE,qBAAA;AV62BF;;AUt2BA;EAEE,cAAA;AVw2BF;;AUr2BA;EACM,2BAAA;AVw2BN;;AUt2BA;EACE,2BAAA;AVy2BF;;AUv2BA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AV02BF;;AUv2BA;EACE,aAAA;EACA,iBAAA;AV02BF;;AUv2BA;EACE,mCAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AV02BF;AUx2BE;EACE,kBAAA;AV02BJ;;AUt2BA;EACE,kBAAA;EACA,kBAAA;AVy2BF;;AUv2BA;EACE,YAAA;EAEA,wCAAA;EACA,yBAAA;EACA,kBAAA;AVy2BF;AUv2BE;EACE,gBAAA;AVy2BJ;AUv2BE;EACE,WAAA;AVy2BJ;;AUr2BA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;AVw2BF;;AUr2BA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AVw2BF;;AUr2BA;EACE,sBAAA;EACA,YAAA;AVw2BF;;AUr2BA;EACE,sBAAA;EACA,eAAA;EACA,0BAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AVw2BF;;AUt2BA;EACE,sBAAA;EACA,eAAA;EACA,0BAAA;EACA,UAAA;AVy2BF;;AUv2BA;EACE,iCAAA;AV02BF;;AUx2BA;EACE,sBAAA;AV22BF;;AUz2BA;EACE,iDAAA;EACA,mDAAA;AV42BF;;AUz2BE;EACE,8BAAA;AV42BJ;;AUx2BE;EACE,8BAAA;AV22BJ;;AUx2BA;EACE,uBAAA;AV22BF;;AUz2BA;EAEE,kCAAA;EACA,YAAA;EACA,kCAAA;EACA,6BAAA;AV22BF;;AUz2BA;EACE,6BAAA;EACA,kBAAA;AV42BF;;AU12BA;EACE,oCAAA;AV62BF;;AU32BA;EACE,kCAAA;AV82BF;;AU32BE;EADF;IAEI,WAAA;EV+2BF;AACF;;AU52BA;EACE,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AV+2BF;;AU32BE;EACE,qBAAA;AV82BJ;AUn2BA;EACI,eAAA;EACI,oBAAA;EACJ,aAAA;AVq2BJ;;AUn2BA;EACI,eAAA;EACE,oBAAA;EACF,aAAA;AVs2BJ;;AUn2BA;EACE,2BAAA;AVs2BF;;AUl2BE;EADF;IAEI,wBAAA;EVs2BF;AACF;;AUp2BA;EACE,4CAAA;EACA,gDAAA,EAAA,iBAAA;EACA,sDAAA,EAAA,mBAAA;EACA,8CAAA;AVu2BF;;AUp2BA;EAAO,iBAAA;AVw2BP;;AUv2BA;EAAO,uBAAA;AV22BP;;AU12BA;EAAO,sBAAA;AV82BP;;AU72BA;EAAO,oBAAA;AVi3BP;;AUh3BA;EAAO,sBAAA;AVo3BP;;AUn3BA;EAAO,oBAAA;AVu3BP;;AUp3BA;EAAQ,wBAAA;AVw3BR;;AUv3BA;EAAQ,8BAAA;AV23BR;;AU13BA;EAAQ,6BAAA;AV83BR;;AU73BA;EAAQ,2BAAA;AVi4BR;;AUh4BA;EAAQ,6BAAA;AVo4BR;;AUn4BA;EAAQ,2BAAA;AVu4BR;;AUp4BA;EAAQ,qBAAA;AVw4BR;;AUv4BA;EAAQ,2BAAA;AV24BR;;AU14BA;EAAQ,0BAAA;AV84BR;;AU74BA;EAAQ,wBAAA;AVi5BR;;AUh5BA;EAAQ,0BAAA;AVo5BR;;AUn5BA;EAAQ,wBAAA;AVu5BR;;AUt5BA;EACE,YAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;AVy5BF;;AUt5BA;EAAS,mBAAA;EAAqB,oBAAA;AV25B9B;;AU15BA;EAAS,oBAAA;EAAsB,qBAAA;AV+5B/B;;AU95BA;EAAS,aAAA;EAAe,cAAA;AVm6BxB;;AUl6BA;EAAS,oBAAA;EAAsB,qBAAA;AVu6B/B;;AUt6BA;EAAS,oBAAA;EAAsB,qBAAA;AV26B/B;;AU16BA;EAAS,aAAA;EAAe,cAAA;AV+6BxB;;AU96BA;EAAS,oBAAA;EAAsB,qBAAA;AVm7B/B;;AUl7BA;EAAS,oBAAA;EAAsB,qBAAA;AVu7B/B;;AUt7BA;EAAS,aAAA;EAAe,cAAA;AV27BxB;;AU17BA;EAAU,oBAAA;EAAsB,qBAAA;AV+7BhC;;AU97BA;EAAU,oBAAA;EAAsB,qBAAA;AVm8BhC;;AUl8BA;EAAU,aAAA;EAAe,cAAA;AVu8BzB;;AUr8BA,wBAAA;AACA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EV08BjC;EUz8BA;IAAY,oBAAA;IAAsB,qBAAA;EV68BlC;EU58BA;IAAY,aAAA;IAAe,cAAA;EVg9B3B;EU/8BA;IAAY,oBAAA;IAAsB,qBAAA;EVm9BlC;EUl9BA;IAAY,oBAAA;IAAsB,qBAAA;EVs9BlC;EUr9BA;IAAY,aAAA;IAAe,cAAA;EVy9B3B;EUx9BA;IAAY,oBAAA;IAAsB,qBAAA;EV49BlC;EU39BA;IAAY,oBAAA;IAAsB,qBAAA;EV+9BlC;EU99BA;IAAY,aAAA;IAAe,cAAA;EVk+B3B;EUj+BA;IAAa,oBAAA;IAAsB,qBAAA;EVq+BnC;EUp+BA;IAAa,oBAAA;IAAsB,qBAAA;EVw+BnC;EUv+BA;IAAa,aAAA;IAAe,cAAA;EV2+B5B;AACF;AUz+BA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EV6+BjC;EU5+BA;IAAY,oBAAA;IAAsB,qBAAA;EVg/BlC;EU/+BA;IAAY,aAAA;IAAe,cAAA;EVm/B3B;EUl/BA;IAAY,oBAAA;IAAsB,qBAAA;EVs/BlC;EUr/BA;IAAY,oBAAA;IAAsB,qBAAA;EVy/BlC;EUx/BA;IAAY,aAAA;IAAe,cAAA;EV4/B3B;EU3/BA;IAAY,oBAAA;IAAsB,qBAAA;EV+/BlC;EU9/BA;IAAY,oBAAA;IAAsB,qBAAA;EVkgClC;EUjgCA;IAAY,aAAA;IAAe,cAAA;EVqgC3B;EUpgCA;IAAa,oBAAA;IAAsB,qBAAA;EVwgCnC;EUvgCA;IAAa,oBAAA;IAAsB,qBAAA;EV2gCnC;EU1gCA;IAAa,cAAA;IAAgB,eAAA;EV8gC7B;AACF;AU5gCA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVghCjC;EU/gCA;IAAY,oBAAA;IAAsB,qBAAA;EVmhClC;EUlhCA;IAAY,aAAA;IAAe,cAAA;EVshC3B;EUrhCA;IAAY,oBAAA;IAAsB,qBAAA;EVyhClC;EUxhCA;IAAY,oBAAA;IAAsB,qBAAA;EV4hClC;EU3hCA;IAAY,aAAA;IAAe,cAAA;EV+hC3B;EU9hCA;IAAY,oBAAA;IAAsB,qBAAA;EVkiClC;EUjiCA;IAAY,oBAAA;IAAsB,qBAAA;EVqiClC;EUpiCA;IAAY,aAAA;IAAe,cAAA;EVwiC3B;EUviCA;IAAa,oBAAA;IAAsB,qBAAA;EV2iCnC;EU1iCA;IAAa,oBAAA;IAAsB,qBAAA;EV8iCnC;EU7iCA;IAAa,aAAA;IAAe,cAAA;EVijC5B;AACF;AU/iCA,6BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVmjCjC;EUljCA;IAAY,oBAAA;IAAsB,qBAAA;EVsjClC;EUrjCA;IAAY,aAAA;IAAe,cAAA;EVyjC3B;EUxjCA;IAAY,oBAAA;IAAsB,qBAAA;EV4jClC;EU3jCA;IAAY,oBAAA;IAAsB,qBAAA;EV+jClC;EU9jCA;IAAY,aAAA;IAAe,cAAA;EVkkC3B;EUjkCA;IAAY,oBAAA;IAAsB,qBAAA;EVqkClC;EUpkCA;IAAY,oBAAA;IAAsB,qBAAA;EVwkClC;EUvkCA;IAAY,aAAA;IAAe,cAAA;EV2kC3B;EU1kCA;IAAa,oBAAA;IAAsB,qBAAA;EV8kCnC;EU7kCA;IAAa,oBAAA;IAAsB,qBAAA;EVilCnC;EUhlCA;IAAa,aAAA;IAAe,cAAA;EVolC5B;AACF;AUllCA,6BAAA,QAAA;EACE;IAAa,mBAAA;IAAqB,oBAAA;EVslClC;EUrlCA;IAAa,oBAAA;IAAsB,qBAAA;EVylCnC;EUxlCA;IAAa,aAAA;IAAe,cAAA;EV4lC5B;EU3lCA;IAAa,oBAAA;IAAsB,qBAAA;EV+lCnC;EU9lCA;IAAa,oBAAA;IAAsB,qBAAA;EVkmCnC;EUjmCA;IAAa,aAAA;IAAe,cAAA;EVqmC5B;EUpmCA;IAAa,oBAAA;IAAsB,qBAAA;EVwmCnC;EUvmCA;IAAa,oBAAA;IAAsB,qBAAA;EV2mCnC;EU1mCA;IAAa,aAAA;IAAe,cAAA;EV8mC5B;EU7mCA;IAAc,oBAAA;IAAsB,qBAAA;EVinCpC;EUhnCA;IAAc,oBAAA;IAAsB,qBAAA;EVonCpC;EUnnCA;IAAc,aAAA;IAAe,cAAA;EVunC7B;AACF;AUtnCA;EACE,0BAAA;AVwnCF;;AUtnCA;EACE,iBAAA;AVynCF;;AUvnCA;EACI,4CAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;AV0nCJ;;AUvnCA;EACI,uBAAA;AV0nCJ;;AUvnCA;EACI,aAAA;AV0nCJ;;AUvnCA;EAEI,gCAAA;EACA,oCAAA;AVynCJ;;AAnsEA;;EAEE,oBAAA;AAssEF;;AAlsEE;EACE,kBAAA;EACA,WAAA;AAqsEJ;AAlsEE;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EAEA,wHAAA;AAmsEJ;AA/rEE;EACE,kBAAA;AAisEJ;AA9rEE;EACE,sBAAA;AAgsEJ;;AA5rEA;EACE,aAAA;EACA,uBAAA;AA+rEF;AA7rEE;EACE,wBAAA;AA+rEJ;;AA3rEA;EACE,WAAA;EACA,uBAAA;AA8rEF;;AA3rEA;EACE,YAAA;AA8rEF;;AA3rEA;EACE,YAAA;AA8rEF;;AA5rEA;EACE,WAAA;AA+rEF;;AA7rEA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;AAgsEF","sourcesContent":["@import \"src/styles\";\n\nion-button,\nion-input{\n  pointer-events: auto;\n}\n\n.select-wrapper {\n  .select-field {\n    position: relative;\n    width: 100%;\n  }\n\n  .filtered-list {\n    max-height: 10rem;\n    overflow-y: auto;\n    cursor: pointer;\n    position: absolute;\n    z-index: 11;\n    width: 100%;\n\n    box-shadow: 0px 7px 5px 1px rgba(0, 0, 0, 0.12),\n      0px 4px 4px 3px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);\n  }\n\n  .no-results {\n    font-style: italic;\n  }\n\n  ion-icon {\n    color: map-get($dark-color, 700);\n  }\n}\n\n.inner-padding {\n  display: flex;\n  justify-content: center;\n\n  .select-wrapper {\n    width: calc(100% - 2rem);\n  }\n}\n\nion-input {\n  width: 100%;\n  background-color: white;\n}\n\n.mobile {\n  width: 270px;\n}\n\n.desktop {\n  width: 370px;\n}\n.width-full{\n  width: 100%;\n}\n.clear-button {\n  position: absolute;\n  right: 8px;\n  z-index: 1;\n}","@use '@angular/cdk';\n\n@mixin ripple() {\n  // The host element of an mat-ripple directive should always have a position of \"absolute\" or\n  // \"relative\" so that the ripples inside are correctly positioned relatively to the container.\n  .mat-ripple {\n    overflow: hidden;\n\n    // By default, every ripple container should have position: relative in favor of creating an\n    // easy API for developers using the MatRipple directive.\n    position: relative;\n\n    // Promote containers that have ripples to a new layer. We want to target `:not(:empty)`,\n    // because we don't want all ripple containers to have their own layer since they're used in a\n    // lot of places and the layer is only relevant while animating. Note that ideally we'd use\n    // the `contain` property here (see #13175), because `:empty` can be broken by having extra\n    // text inside the element, but it isn't very well supported yet.\n    &:not(:empty) {\n      transform: translateZ(0);\n    }\n  }\n\n  .mat-ripple.mat-ripple-unbounded {\n    overflow: visible;\n  }\n\n  .mat-ripple-element {\n    position: absolute;\n    border-radius: 50%;\n    pointer-events: none;\n\n    transition: opacity, transform 0ms cubic-bezier(0, 0, 0.2, 1);\n\n    // We use a 3d transform here in order to avoid an issue in Safari where\n    // the ripples aren't clipped when inside the shadow DOM (see #24028).\n    transform: scale3d(0, 0, 0);\n\n    // In high contrast mode the ripple is opaque, causing it to obstruct the content.\n    @include cdk.high-contrast(active, off) {\n      display: none;\n    }\n  }\n}\n","/// Emits a CSS class, `.cdk-visually-hidden`. This class can be applied to an element\n/// to make that element visually hidden while remaining available to assistive technology.\n@mixin a11y-visually-hidden() {\n  .cdk-visually-hidden {\n    border: 0;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px;\n\n    // This works around a Chrome bug that can cause the tab to crash when large amounts of\n    // non-English text get wrapped: https://bugs.chromium.org/p/chromium/issues/detail?id=1201444\n    white-space: nowrap;\n\n    // Avoid browsers rendering the focus ring in some cases.\n    outline: 0;\n\n    // Avoid some cases where the browser will still render the native controls (see #9049).\n    -webkit-appearance: none;\n    -moz-appearance: none;\n\n    // We need at least one of top/bottom/left/right in order to prevent cases where the\n    // absolute-positioned element is pushed down and can affect scrolling (see #24597).\n    // `left` was chosen here, because it's the least likely to break overrides where the\n    // element might have been positioned (e.g. `mat-checkbox`).\n    left: 0;\n\n    [dir='rtl'] & {\n      left: auto;\n      right: 0;\n    }\n  }\n}\n\n/// @deprecated Use `a11y-visually-hidden`.\n@mixin a11y() {\n  @include a11y-visually-hidden;\n}\n\n/// Emits the mixin's content nested under `$selector-context` if `$selector-context`\n/// is non-empty.\n/// @param {String} selector-context The selector under which to nest the mixin's content.\n@mixin _optionally-nest-content($selector-context) {\n  @if ($selector-context == '') {\n    @content;\n  }\n  @else {\n    #{$selector-context} {\n      @content;\n    }\n  }\n}\n\n/// Applies styles for users in high contrast mode. Note that this only applies\n/// to Microsoft browsers. Chrome can be included by checking for the `html[hc]`\n/// attribute, however Chrome handles high contrast differently.\n///\n/// @param {String} target Type of high contrast setting to target. Defaults to `active`, can be\n///     `white-on-black` or `black-on-white`.\n/// @param {String} encapsulation Whether to emit styles for view encapsulation. Values are:\n///     * `on` - works for `Emulated`, `Native`, and `ShadowDom`\n///     * `off` - works for `None`\n///     * `any` - works for all encapsulation modes by emitting the CSS twice (default).\n@mixin high-contrast($target: active, $encapsulation: 'any') {\n  @if ($target != 'active' and $target != 'black-on-white' and $target != 'white-on-black') {\n    @error 'Unknown cdk-high-contrast value \"#{$target}\" provided. ' +\n           'Allowed values are \"active\", \"black-on-white\", and \"white-on-black\"';\n  }\n\n  @if ($encapsulation != 'on' and $encapsulation != 'off' and $encapsulation != 'any') {\n    @error 'Unknown cdk-high-contrast encapsulation \"#{$encapsulation}\" provided. ' +\n           'Allowed values are \"on\", \"off\", and \"any\"';\n  }\n\n  // If the selector context has multiple parts, such as `.section, .region`, just doing\n  // `.cdk-high-contrast-xxx #{&}` will only apply the parent selector to the first part of the\n  // context. We address this by nesting the selector context under .cdk-high-contrast.\n  @at-root {\n    $selector-context: #{&};\n\n    @if ($encapsulation != 'on') {\n      // Note that if this selector is updated, the same change has to be made inside\n      // `_overlay.scss` which can't depend on this mixin due to some infrastructure limitations.\n      .cdk-high-contrast-#{$target} {\n        @include _optionally-nest-content($selector-context) {\n          @content;\n        }\n      }\n    }\n\n    @if ($encapsulation != 'off') {\n      .cdk-high-contrast-#{$target} :host {\n        @include _optionally-nest-content($selector-context) {\n          @content;\n        }\n      }\n    }\n  }\n}\n","// We want overlays to always appear over user content, so set a baseline\n// very high z-index for the overlay container, which is where we create the new\n// stacking context for all overlays.\n$overlay-container-z-index: 1000 !default;\n$overlay-z-index: 1000 !default;\n$overlay-backdrop-z-index: 1000 !default;\n\n// Background color for all of the backdrops\n$overlay-backdrop-color: rgba(0, 0, 0, 0.32) !default;\n\n// Default backdrop animation is based on the Material Design swift-ease-out.\n$backdrop-animation-duration: 400ms !default;\n$backdrop-animation-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1) !default;\n\n/// Emits structural styles required for cdk/overlay to function.\n@mixin overlay() {\n  .cdk-overlay-container, .cdk-global-overlay-wrapper {\n    // Disable events from being captured on the overlay container.\n    pointer-events: none;\n\n    // The container should be the size of the viewport.\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n  }\n\n  // The overlay-container is an invisible element which contains all individual overlays.\n  .cdk-overlay-container {\n    position: fixed;\n    z-index: $overlay-container-z-index;\n\n    &:empty {\n      // Hide the element when it doesn't have any child nodes. This doesn't\n      // include overlays that have been detached, rather than disposed.\n      display: none;\n    }\n  }\n\n  // We use an extra wrapper element in order to use make the overlay itself a flex item.\n  // This makes centering the overlay easy without running into the subpixel rendering\n  // problems tied to using `transform` and without interfering with the other position\n  // strategies.\n  .cdk-global-overlay-wrapper {\n    display: flex;\n    position: absolute;\n    z-index: $overlay-z-index;\n  }\n\n  // A single overlay pane.\n  .cdk-overlay-pane {\n    // Note: it's important for this one to start off `absolute`,\n    // in order for us to be able to measure it correctly.\n    position: absolute;\n    pointer-events: auto;\n    box-sizing: border-box;\n    z-index: $overlay-z-index;\n\n    // For connected-position overlays, we set `display: flex` in\n    // order to force `max-width` and `max-height` to take effect.\n    display: flex;\n    max-width: 100%;\n    max-height: 100%;\n  }\n\n  .cdk-overlay-backdrop {\n    // TODO(jelbourn): reuse sidenav fullscreen mixin.\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n\n    z-index: $overlay-backdrop-z-index;\n    pointer-events: auto;\n    -webkit-tap-highlight-color: transparent;\n    transition: opacity $backdrop-animation-duration $backdrop-animation-timing-function;\n    opacity: 0;\n\n    &.cdk-overlay-backdrop-showing {\n      opacity: 1;\n\n      // Note that we can't import and use the `high-contrast` mixin from `_a11y.scss`, because\n      // this file will be copied to the top-level `cdk` package when putting together the files\n      // for npm. Any relative import paths we use here will become invalid once the file is copied.\n      .cdk-high-contrast-active & {\n        // In high contrast mode the rgba background will become solid\n        // so we need to fall back to making it opaque using `opacity`.\n        opacity: 0.6;\n      }\n    }\n  }\n\n  .cdk-overlay-dark-backdrop {\n    background: $overlay-backdrop-color;\n  }\n\n  .cdk-overlay-transparent-backdrop {\n    // Define a transition on the visibility so that the `transitionend` event can fire immediately.\n    transition: visibility 1ms linear, opacity 1ms linear;\n    visibility: hidden;\n    opacity: 1;\n\n    // Note: as of Firefox 57, having the backdrop be `background: none` will prevent it from\n    // capturing the user's mouse scroll events. Since we also can't use something like\n    // `rgba(0, 0, 0, 0)`, we work around the inconsistency by not setting the background at\n    // all and using `opacity` to make the element transparent.\n    &.cdk-overlay-backdrop-showing {\n      opacity: 0;\n      visibility: visible;\n    }\n  }\n\n  .cdk-overlay-backdrop-noop-animation {\n    transition: none;\n  }\n\n  // Overlay parent element used with the connected position strategy. Used to constrain the\n  // overlay element's size to fit within the viewport.\n  .cdk-overlay-connected-position-bounding-box {\n    position: absolute;\n    z-index: $overlay-z-index;\n\n    // We use `display: flex` on this element exclusively for centering connected overlays.\n    // When *not* centering, a top/left/bottom/right will be set which overrides the normal\n    // flex layout.\n    display: flex;\n\n    // We use the `column` direction here to avoid some flexbox issues in Edge\n    // when using the \"grow after open\" options.\n    flex-direction: column;\n\n    // Add some dimensions so the element has an `innerText` which some people depend on in tests.\n    min-width: 1px;\n    min-height: 1px;\n  }\n\n  // Used when disabling global scrolling.\n  .cdk-global-scrollblock {\n    position: fixed;\n\n    // Necessary for the content not to lose its width. Note that we're using 100%, instead of\n    // 100vw, because 100vw includes the width plus the scrollbar, whereas 100% is the width\n    // that the element had before we made it `fixed`.\n    width: 100%;\n\n    // Note: this will always add a scrollbar to whatever element it is on, which can\n    // potentially result in double scrollbars. It shouldn't be an issue, because we won't\n    // block scrolling on a page that doesn't have a scrollbar in the first place.\n    overflow-y: scroll;\n  }\n}\n","// Structural styles for the autosize text fields.\n@mixin text-field-autosize() {\n  // Remove the resize handle on autosizing textareas, because whatever height\n  // the user resized to will be overwritten once they start typing again.\n  textarea.cdk-textarea-autosize {\n    resize: none;\n  }\n\n  // This class is temporarily applied to the textarea when it is being measured. It is immediately\n  // removed when measuring is complete. We use `!important` rules here to make sure user-specified\n  // rules do not interfere with the measurement.\n  textarea.cdk-textarea-autosize-measuring {\n    @include _autosize-measuring-base;\n    height: auto !important;\n    overflow: hidden !important;\n  }\n\n  // Similar to the `cdk-textarea-autosize-measuring` class, but only applied on Firefox. We need\n  // to use this class, because Firefox has a bug where changing the `overflow` breaks the user's\n  // ability to undo/redo what they were typing (see #16629). This class is only scoped to Firefox,\n  // because the measurements there don't seem to be affected by the `height: 0`, whereas on other\n  // browsers they are, e.g. Chrome detects longer text and IE does't resize back to normal.\n  // Identical issue report: https://bugzilla.mozilla.org/show_bug.cgi?id=448784\n  textarea.cdk-textarea-autosize-measuring-firefox {\n    @include _autosize-measuring-base;\n    height: 0 !important;\n  }\n}\n\n// Core styles that enable monitoring autofill state of text fields.\n@mixin text-field-autofill() {\n  // Keyframes that apply no styles, but allow us to monitor when an text field becomes autofilled\n  // by watching for the animation events that are fired when they start. Note: the /*!*/ comment is\n  // needed to prevent LibSass from stripping the keyframes out.\n  // Based on: https://medium.com/@brunn/detecting-autofilled-fields-in-javascript-aed598d25da7\n  @keyframes cdk-text-field-autofill-start {/*!*/}\n  @keyframes cdk-text-field-autofill-end {/*!*/}\n\n  .cdk-text-field-autofill-monitored:-webkit-autofill {\n    // Since Chrome 80 we need a 1ms delay, or the animationstart event won't fire.\n    animation: cdk-text-field-autofill-start 0s 1ms;\n  }\n\n  .cdk-text-field-autofill-monitored:not(:-webkit-autofill) {\n    // Since Chrome 80 we need a 1ms delay, or the animationstart event won't fire.\n    animation: cdk-text-field-autofill-end 0s 1ms;\n  }\n}\n\n@mixin _autosize-measuring-base {\n  // Having 2px top and bottom padding seems to fix a bug where Chrome gets an incorrect\n  // measurement. We just have to account for it later and subtract it off the final result.\n  padding: 2px 0 !important;\n  box-sizing: content-box !important;\n}\n\n// Used to generate UIDs for keyframes used to change the text field autofill styles.\n$autofill-color-frame-count: 0;\n\n// Mixin used to apply custom background and foreground colors to an autofilled text field.\n// Based on: https://stackoverflow.com/questions/2781549/\n// removing-input-background-colour-for-chrome-autocomplete#answer-37432260\n@mixin text-field-autofill-color($background, $foreground:'') {\n  @keyframes cdk-text-field-autofill-color-#{$autofill-color-frame-count} {\n    to {\n      background: $background;\n      @if $foreground != '' { color: $foreground; }\n    }\n  }\n\n  &:-webkit-autofill {\n    animation: cdk-text-field-autofill-color-#{$autofill-color-frame-count} both;\n  }\n\n  &.cdk-text-field-autofill-monitored:-webkit-autofill {\n    // Since Chrome 80 we need a 1ms delay for cdk-text-field-autofill-start, or the animationstart\n    // event won't fire.\n    animation: cdk-text-field-autofill-start 0s 1ms,\n               cdk-text-field-autofill-color-#{$autofill-color-frame-count} both;\n  }\n\n  $autofill-color-frame-count: $autofill-color-frame-count + 1 !global;\n}\n\n// @deprecated Use `autosize` and `autofill` instead.\n@mixin text-field {\n  @include text-field-autosize();\n  @include text-field-autofill();\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use '@angular/cdk';\n@use '../style/layout-common';\n@use '../theming/theming';\n\n// Private sass variables that will be used as reference throughout component stylesheets.\n$default-border-width: 3px;\n$default-border-style: solid;\n$default-border-color: transparent;\n$default-border-radius: 4px;\n\n// Mixin that renders the focus indicator structural styles.\n@mixin structural-styling($prefix) {\n  .#{$prefix}-focus-indicator {\n    position: relative;\n\n    &::before {\n      @include layout-common.fill();\n      box-sizing: border-box;\n      pointer-events: none;\n      display: var(--#{$prefix}-focus-indicator-display, none); // Hide the indicator by default.\n      border: var(\n          --#{$prefix}-focus-indicator-border-width,\n          #{$default-border-width}\n        )\n        var(\n          --#{$prefix}-focus-indicator-border-style,\n          #{$default-border-style}\n        )\n        var(\n          --#{$prefix}-focus-indicator-border-color,\n          #{$default-border-color}\n        );\n      border-radius: var(\n        --#{$prefix}-focus-indicator-border-radius,\n        #{$default-border-radius}\n      );\n    }\n\n    // By default, render the focus indicator when the focus indicator host element takes focus.\n    // Defining a pseudo element's content will cause it to render.\n    &:focus::before {\n      content: '';\n    }\n  }\n\n  // Enable the indicator in high contrast mode.\n  @include cdk.high-contrast(active, off) {\n    @include customize-focus-indicators((display: block), $prefix);\n  }\n}\n\n// Generates CSS variable declarations from a map.\n@mixin _output-variables($map) {\n  @each $key, $value in $map {\n    @if ($value) {\n      --#{$key}: #{$value};\n    }\n  }\n}\n\n// Mixin that dedups CSS variables for the strong-focus-indicators mixin.\n@mixin customize-focus-indicators($config, $prefix) {\n  $border-style: map.get($config, border-style);\n  $border-width: map.get($config, border-width);\n  $border-radius: map.get($config, border-radius);\n  $border-color: map.get($config, border-color);\n  $display: map.get($config, display);\n  $map: (\n    '#{$prefix}-focus-indicator-border-style': $border-style,\n    '#{$prefix}-focus-indicator-border-width': $border-width,\n    '#{$prefix}-focus-indicator-border-radius': $border-radius,\n    '#{$prefix}-focus-indicator-border-color': $border-color,\n    '#{$prefix}-focus-indicator-display': $display,\n  );\n\n  @if (&) {\n    @include _output-variables($map);\n  }\n  @else {\n    // We use `html` here instead of `:root`, because the\n    // latter causes some issues with internal tooling.\n    html {\n      @include _output-variables($map);\n    }\n  }\n}\n\n@mixin strong-focus-indicators($config: ()) {\n  // Default focus indicator config.\n  $default-config: (\n      border-color: black,\n      display: block,\n  );\n\n  // Merge default config with user config.\n  $config: map.merge($default-config, $config);\n\n  @include customize-focus-indicators($config, 'mat');\n}\n\n@mixin mdc-strong-focus-indicators($config: ()) {\n  // Default focus indicator config.\n  $default-config: (\n      border-color: black,\n      display: block,\n  );\n\n  // Merge default config with user config.\n  $config: map.merge($default-config, $config);\n\n  @include customize-focus-indicators($config, 'mat-mdc');\n}\n\n@mixin strong-focus-indicators-color($config-or-theme-or-color) {\n  @if meta.type-of($config-or-theme-or-color) == 'color' {\n    @include customize-focus-indicators((\n        border-color: $config-or-theme-or-color\n    ), 'mat');\n  }\n  @else {\n    $config: theming.get-color-config($config-or-theme-or-color);\n    $border-color: theming.get-color-from-palette(map.get($config, primary));\n    @include customize-focus-indicators((\n        border-color: $border-color\n    ), 'mat');\n  }\n}\n\n@mixin strong-focus-indicators-theme($theme-or-color-config-or-color) {\n  @if meta.type-of($theme-or-color-config-or-color) == 'color' {\n    @include customize-focus-indicators((\n        border-color: $theme-or-color-config-or-color\n    ), 'mat');\n  }\n  @else {\n    $theme: theming.private-legacy-get-theme($theme-or-color-config-or-color);\n    @include theming.private-check-duplicate-theme-styles($theme, 'mat-focus-indicators') {\n      $color: theming.get-color-config($theme);\n      @if $color != null {\n        @include strong-focus-indicators-color($color);\n      }\n    }\n  }\n}\n\n@mixin mdc-strong-focus-indicators-color($config-or-theme-or-color) {\n  @if meta.type-of($config-or-theme-or-color) == 'color' {\n    @include customize-focus-indicators((\n        border-color: $config-or-theme-or-color\n    ), 'mat-mdc');\n  }\n  @else {\n    $config: theming.get-color-config($config-or-theme-or-color);\n    $border-color: theming.get-color-from-palette(map.get($config, primary));\n    @include customize-focus-indicators((\n        border-color: $border-color\n    ), 'mat-mdc');\n  }\n}\n\n@mixin mdc-strong-focus-indicators-theme($theme-or-color-config-or-color) {\n  @if meta.type-of($theme-or-color-config-or-color) == 'color' {\n    @include customize-focus-indicators((\n        border-color: $theme-or-color-config-or-color\n    ), 'mat-mdc');\n  }\n  @else {\n    $theme: theming.private-legacy-get-theme($theme-or-color-config-or-color);\n    @include theming.private-check-duplicate-theme-styles($theme, 'mat-mdc-focus-indicators') {\n      $color: theming.get-color-config($theme);\n      @if $color != null {\n        @include mdc-strong-focus-indicators-color($color);\n      }\n    }\n  }\n}\n","// This mixin ensures an element spans to fill the nearest ancestor with defined positioning.\n@mixin fill {\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  position: absolute;\n}\n","/* \n\tColors values \n\t300 = tint\n\t500 = default\n\t700 = shade\n*/\n$primary-color: (\n  500: rgba(174, 15, 10, 1),\n  300: rgba(227, 6, 19, 1),\n  700: rgba(228, 173, 181, 1),\n  contrast: (500: white,\n    300: white,\n    700: black,\n  ),\n);\n$secondary-color: (\n  500: rgba(0, 87, 158, 1),\n  300: rgba(51, 125, 192, 1),\n  700: rgba(0, 59, 109, 1),\n  contrast: (500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$warning-color: (\n  500: rgba(255, 196, 9, 1),\n  300: rgba(255, 202, 34, 1),\n  700: rgba(224, 172, 8, 1),\n  contrast: (500: black,\n    300: black,\n    700: black,\n  ),\n);\n\n$danger-color: (\n  500: rgba(235, 68, 90, 1),\n  300: rgba(237, 87, 107, 1),\n  700: rgba(207, 60, 79, 1),\n  contrast: (500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$success-color: (\n  500: rgba(45, 211, 111, 1),\n  300: rgba(66, 215, 125, 1),\n  700: rgba(40, 186, 98, 1),\n  contrast: (500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$dark-color: (\n  500: rgba(34, 36, 40, 1),\n  300: rgba(60, 60, 59, 1),\n  700: rgba(87, 87, 86, 1),\n  contrast: (500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$medium-color: (\n  500: rgba(112, 111, 111, 1),\n  300: rgba(135, 135, 135, 1),\n  700: rgba(189, 188, 188, 1),\n  contrast: (500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$light-color: (\n  500: rgba(227, 227, 227, 1),\n  300: rgba(245, 246, 249, 1),\n  700: rgba(189, 188, 188, 1),\n  contrast: (500: black,\n    300: black,\n    700: black,\n  ),\n);","@import \"variables\";\n\nbody {\n  font-family: \"Barlow\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 19px;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 600;\n}\n\nh1 {\n  font-size: 64px;\n  line-height: 78px;\n}\n\nh2 {\n  font-size: 56px;\n  line-height: 68px;\n}\n\nh3 {\n  font-size: 48px;\n  line-height: 58px;\n}\n\nh4 {\n  font-size: 40px;\n  line-height: 48px;\n}\n\nh5 {\n  font-size: 32px;\n  line-height: 39px;\n}\n\nh6 {\n  font-size: 24px;\n  line-height: 29px;\n}\n\na {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 19px;\n  color: map-get($primary-color, 500);\n  cursor: pointer;\n  text-decoration: underline;\n}\n\ncaption {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 14px;\n}\n\nth {\n  font-weight: 700;\n  cursor: pointer;\n}\n","$spacing-sizes: (\n  0: 0px,\n  1: 8px,\n  2: 16px,\n  3: 24px,\n  4: 32px,\n  5: 40px,\n  6: 48px,\n  7: 56px,\n  8: 64px,\n  9: 72px,\n  10: 80px,\n);\n\n@each $key, $size in $spacing-sizes {\n  .p-#{$key} {\n    padding: #{$size};\n  }\n  .pt-#{$key} {\n    padding-top: #{$size};\n  }\n  .pr-#{$key} {\n    padding-right: #{$size};\n  }\n  .pb-#{$key} {\n    padding-bottom: #{$size};\n  }\n  .pl-#{$key} {\n    padding-left: #{$size};\n  }\n  .px-#{$key} {\n    padding-left: #{$size};\n    padding-right: #{$size};\n  }\n  .py-#{$key} {\n    padding-top: #{$size};\n    padding-bottom: #{$size};\n  }\n\n  .m-#{$key} {\n    margin: #{$size};\n  }\n  .mt-#{$key} {\n    margin-top: #{$size};\n  }\n  .mr-#{$key} {\n    margin-right: #{$size};\n  }\n  .mb-#{$key} {\n    margin-bottom: #{$size};\n  }\n  .ml-#{$key} {\n    margin-left: #{$size};\n  }\n  .mx-#{$key} {\n    margin-left: #{$size};\n    margin-right: #{$size};\n  }\n  .my-#{$key} {\n    margin-top: #{$size};\n    margin-bottom: #{$size};\n  }\n}\n","@use \"@angular/material\" as mat;\n@include mat.core();\n@import url(\"https://fonts.googleapis.com/icon?family=Material+Icons\");\n@import \"theme/typography.scss\";\n@import \"theme/variables.scss\";\n@import \"theme/spacing\";\n@import url(\"https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap\");\nhtml {\n  --mdc-outlined-text-field-focus-outline-color: rgba(\n    135,\n    135,\n    135,\n    1\n  ) !important;\n  --mdc-outlined-text-field-focus-label-text-color: rgba(\n    135,\n    135,\n    135,\n    1\n  ) !important;\n\n  --mat-option-selected-state-label-text-color: rgba(\n    135,\n    135,\n    135,\n    1\n  ) !important;\n\n  --mat-datepicker-toggle-active-state-icon-color: rgba(\n    174,\n    15,\n    10,\n    1\n  ) !important;\n\n  --mdc-filled-text-field-focus-active-indicator-color: rgba(\n    135,\n    135,\n    135,\n    1\n  ) !important;\n\n  --mat-sidenav-content-background-color: white !important;\n}\n\n/* You can add global styles to this file, and also import other style files */\n/* Angular 15 adds grey background on mat form components */\n/* below removes that background color */\n/* Manipulate initial background color*/\n.mdc-text-field--filled:not(.mdc-text-field--disabled) {\n  background-color: transparent !important;\n}\n\n/*Manipulate background color on hover and focus*/\n.mat-mdc-form-field-focus-overlay {\n  background-color: transparent !important;\n}\n\n.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted {\n  width: 0px;\n  padding-left: 6px;\n  padding-right: 6px;\n\n  span {\n    display: none;\n  }\n}\n\n/* Pagination menu */\n.g-bubble-container {\n  display: flex;\n  gap: 4px;\n  margin-left: 8px;\n}\n\n.g-bubble {\n  background-color: map-get($light-color, 300);\n  border-radius: 4px;\n  width: 34px;\n  height: 34px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: map-get($dark-color, 500) !important;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: 0.3s;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 0.5px;\n  text-align: center;\n  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12),\n    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);\n}\n\n.g-bubble:hover {\n  background-color: map-get($light-color, 700);\n  color: map-get($light-color, 300);\n}\n\n.g-bubble__active {\n  background-color: map-get($primary-color, 300);\n  color: map-get($light-color, 500) !important;\n  box-shadow: 0px 5px 14px 0px rgba(0, 0, 0, 0.12),\n    0px 9px 10px 0px rgba(0, 0, 0, 0.14), 0px 5px 5px 0px rgba(0, 0, 0, 0.2);\n}\n\nmat-paginator {\n  background: transparent !important;\n}\n\n.mat-mdc-paginator-range-actions {\n  margin-right: 12px !important;\n}\n\n.mat-mdc-paginator-container {\n  justify-content: center !important;\n}\n\n.mat-mdc-paginator-navigation-next,\n.mat-mdc-paginator-navigation-previous {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  color: map-get($dark-color, 500) !important;\n  padding: 0 !important;\n  border-radius: 4px !important;\n  width: 34px !important;\n  height: 34px !important;\n  background-color: map-get($light-color, 300) !important;\n  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12),\n    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);\n}\n\n/* End of pagination menu */\n\nbody {\n  margin: 0;\n}\n\n.snackbar {\n  width: 50vw;\n  margin: 10px 0px !important;\n\n  .mdc-snackbar__surface {\n    background-color: map-get($light-color, 300) !important;\n    border-radius: 10px !important;\n    width: 33vw;\n  }\n\n  .mdc-snackbar__label {\n    color: black !important;\n  }\n\n  .mat-icon {\n    margin-right: 12px;\n  }\n}\n\n.snackbar-custom {\n  width: 50vw;\n  margin-top: 75px !important;\n}\n\n.snacbar-warning {\n  width: 50vw;\n  margin: 10px 0px;\n\n  .mdc-snackbar__surface {\n    background-color: map-get($light-color, 300) !important;\n    border-radius: 10px !important;\n    width: 33vw;\n    border: 1px solid #e0ac08;\n  }\n\n  .mdc-snackbar__label {\n    color: black !important;\n  }\n\n  .mat-icon {\n    margin-right: 12px;\n  }\n}\n\n.snacbar-sucess {\n  width: 50vw;\n  margin: 10px 0px;\n\n  .mdc-snackbar__surface {\n    background-color: map-get($light-color, 300) !important;\n    border-radius: 10px !important;\n    width: 33vw;\n    border: 1px solid green;\n  }\n\n  .mdc-snackbar__label {\n    color: black !important;\n  }\n\n  .mat-icon {\n    margin-right: 12px;\n  }\n}\n\n.snacbar-error {\n  width: 50vw;\n  margin: 10px 0px;\n\n  .mdc-snackbar__surface {\n    background-color: map-get($light-color, 300) !important;\n    border-radius: 10px !important;\n    width: 33vw;\n    border: 1px solid red;\n  }\n\n  .mdc-snackbar__label {\n    color: black !important;\n  }\n\n  .mat-icon {\n    margin-right: 12px;\n  }\n}\n\n.flex {\n  display: flex;\n}\n\n.mat-mdc-menu-panel {\n  overflow: hidden !important;\n\n  .mat-mdc-menu-content {\n    .menu-header {\n      font-size: 12px;\n      padding: 1rem;\n      padding-bottom: 0.25rem;\n    }\n\n    .mat-mdc-menu-item {\n      margin-left: 1rem;\n      padding-left: 0;\n    }\n\n    .mat-mdc-menu-item:first-of-type {\n      margin-top: 0.75rem;\n    }\n\n    .mat-mdc-menu-item:not(:last-child) {\n      border-bottom: 1px solid map-get($light-color, 700);\n    }\n  }\n}\n\n.loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 3000;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.sort-icon-container {\n  display: inline-flex;\n  align-items: center;\n\n  mat-icon {\n    height: 1rem;\n    width: 1rem;\n  }\n}\napp-edit-contract{\n  .btn-primary.mat-mdc-unelevated-button.mat-unthemed {\n    @media (max-width: 767px) {\n      margin-top: 15px;\n      margin-right: 0 !important;\n      width: 40% !important;\n      height: 45px;\n    }\n  }\n}\n.btn-primary.mat-mdc-unelevated-button.mat-unthemed {\n  background: map-get($primary-color, 500);\n  color: white;\n  width: 14rem;\n  border-radius: 10px;\n  padding: 0.75rem 0;\n  border: none;\n  font-weight: bold;\n  align-self: center;\n  cursor: pointer;\n\n  @media (max-width: 767px) {\n    margin-top: 15px;\n    margin-right: 0 !important;\n    width: 40%;\n    height: 45px;\n  }\n\n  &[disabled] {\n    background: map-get($medium-color, 700);\n  }\n}\n\n.btn-secondary.mat-mdc-unelevated-button.mat-unthemed {\n  background: white;\n  color: map-get($primary-color, 500);\n  width: 14rem;\n  border-radius: 10px;\n  padding: 0.75rem 0;\n  border: 2px solid map-get($primary-color, 500);\n  font-weight: bold;\n  align-self: center;\n  cursor: pointer;\n\n  @media (max-width: 767px) {\n    margin-top: 15px;\n    width: 100%;\n    height: 45px;\n  }\n\n  &[disabled] {\n    background: map-get($medium-color, 700);\n  }\n}\n\n.btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {\n  background: map-get($medium-color, 700);\n  color: white;\n  width: 14rem;\n  border-radius: 10px;\n  padding: 0.75rem 0;\n  border: none;\n  font-weight: bold;\n  align-self: center;\n  cursor: pointer;\n\n  @media (max-width: 767px) {\n    margin-top: 15px;\n    width: 100%;\n    height: 45px;\n  }\n}\n\n/* \n  IONIC components\n*/\nion-item.no-padding {\n  --padding-end: 0;\n  --padding-start: 0;\n}\n\nion-item.no-padding-full {\n  --padding-end: 0;\n  --padding-start: 0;\n  --inner-padding-end: 0;\n  --inner-padding-start: 0;\n}\nion-checkbox {\n  --checkbox-background-checked: rgba(174, 15, 10, 1);\n  --border-color-checked: rgba(174, 15, 10, 1);\n}\n\nion-input.custom-input {\n  --border-color: rgba(135, 135, 135, 1);\n  --padding-top: 5px;\n  --highlight-color: rgba(135, 135, 135, 1);\n}\nion-input.custom-input-user {\n  --border-color: #EFEFEF;\n  --padding-top: 5px;\n  --highlight-color: rgba(135, 135, 135, 1);\n}\nion-input.width-full {\n  --border-color: #EFEFEF !important;\n  --padding-top: 5px;\n  --highlight-color: rgb(37, 19, 19);\n}\n.filter-panel {\n  max-width: 100vw !important;\n}\n.date-select-modal-filter {\n  .mdc-text-field {\n    height: 35px;\n  }\n  .mat-mdc-form-field-infix {\n    height: 35px;\n    min-height: 35px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-top: 0px !important;\n    padding-bottom: 0px !important;\n  }\n  .select-year {\n    .mat-mdc-text-field-wrapper {\n      background-color: #f4f4f4;\n      border: 1px solid rgb(189, 188, 188);\n    }\n  }\n\n  .mdc-notched-outline__leading {\n    border: none !important;\n  }\n  .mdc-notched-outline__notch {\n    border: none !important;\n  }\n  .mdc-notched-outline__trailing {\n    border: none !important;\n  }\n}\n\n@media (min-width: 1025px) {\n  .filter-panel {\n    max-height: 33rem !important;\n    min-width: 60vw;\n  }\n\n  .anotation-panel {\n    max-width: 30rem !important;\n    max-height: 30rem !important;\n    min-width: 50vw;\n  }\n\n  .historic-panel {\n    min-width: 49.5rem;\n    min-height: 35.625rem;\n    min-width: 50vw;\n  }\n  .segments-panel {\n    width: 72vw;\n    min-width: 760px;\n    max-width: 1100px !important;\n    max-height: 90vh !important;\n  }\n  .new-highway-modal-panel {\n    min-width: 49.5rem;\n    min-height: 23.625rem;\n    min-width: 50vw;\n  }\n}\n\n@media (max-width: 1024px) {\n  .btn-actions {\n    margin-right: 15px;\n  }\n  .filter-panel {\n    min-height: 30rem;\n    max-width: 100vw !important;\n    min-width: 90vw;\n  }\n\n  .historic-panel {\n    max-width: 49.5rem;\n    min-width: 90vw !important;\n  }\n  .segments-panel {\n    max-width: 90vw !important;\n    min-width: 90vw !important;\n    max-height: 90vh !important;\n  }\n    .new-highway-modal-panel {\n  max-width: 49.5rem;\n    min-width: 90vw !important;\n  }\n}\n\n@media (max-width: 1024px) {\n  .anotation-panel {\n    width: 90%;\n  }\n}\n\n.mdc-text-field--filled:not(.mdc-text-field--disabled) {\n  background-color: transparent !important;\n}\n\n@media (max-width: 1024px) {\n  .mat-mdc-form-field-label {\n    font-size: 0.8rem;\n    /* Tamanho de fonte para dispositivos móveis */\n  }\n}\n\n.button_cad {\n  background-color: map-get($primary-color, 500);\n  padding: 0.5rem 2rem;\n  border-radius: 0.5rem;\n  color: #fff;\n  font-style: none;\n  text-decoration: none;\n\n  mat-icon {\n    color: #fff !important;\n  }\n}\n\n::ng-deep.mat-mdc-card-header-text {\n  display: none !important;\n}\n.input-error {\n  border: 1px solid red; /* Ajuste o estilo conforme necessário */\n}\n.card-mobile {\n  min-height: 10rem;\n  margin: 1rem auto;\n  border: 1px solid #cdcdcd;\n\n  .mat-mdc-card-header {\n    width: 90%;\n    display: flex;\n    margin: auto;\n    // align-items: center;\n    justify-content: space-between;\n    padding: 0rem;\n\n    p {\n      font-weight: bolder;\n      font-size: 1.2rem;\n      text-transform: uppercase;\n    }\n\n    span,\n    .subtitle {\n      font-size: 1rem;\n      font-weight: normal;\n      color: #cdcdcd;\n    }\n    @media (max-width: 1024px) {\n      width: 100%;\n      margin: 0 16px;\n    }\n  }\n\n  .mat-mdc-card-footer {\n    margin: 1rem 0rem;\n    border-top: 1px solid black;\n    display: flex;\n    align-items: center;\n\n    button {\n      width: 100%;\n      display: flex;\n      justify-content: flex-end;\n    }\n  }\n\n  .extension {\n    font-weight: bold;\n    color: map-get($primary-color, 500);\n  }\n  .formatAnotation {\n    @media (max-width: 1024px) {\n      padding: 0 16px;\n    }\n  }\n\n  .content-card {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .content-status {\n    width: 40%;\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n\n    p {\n      font-weight: bold;\n    }\n  }\n}\n\n.card-mobile-empty {\n  border: 1px solid #cdcdcd;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nion-button.more-filters-btn {\n  --background: rgba(174, 15, 10, 1);\n  --color: white;\n  --border-radius: 10px;\n  width: 100%;\n  max-width: 15rem;\n  text-transform: capitalize;\n  font-size: 0.9rem;\n  height: 100%;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n}\n\nion-item.fast-filters {\n  padding: 0.25rem 0rem;\n}\n\nion-chip.fast-filter-active-primary {\n  background-color: map-get($success-color, 700);\n  color: white;\n}\n\nion-chip.fast-filter-active-secondary {\n  background-color: map-get($danger-color, 500);\n  color: white;\n}\nion-chip.fast-filter-active-primary-contract {\n\n  color: #AE0F0A;\n  border: 1px solid #AE0F0A;\n  background: #E4ADB5;\n\n}\n\nion-chip.fast-filter-active-secondary-contract {\n  color: #AE0F0A;\n  border: 1px solid #AE0F0A;\n  background: #E4ADB5;\n}\n.more-filters-btn-row {\n  justify-content: center;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n\n  button {\n    margin: 5px;\n  }\n\n  @media (max-width: 767px) {\n    button {\n      margin: 5px 0;\n    }\n  }\n}\n\n.status-container {\n  display: flex;\n  align-items: center;\n\n  .mat-icon {\n    width: 1rem;\n  }\n\n  .status-icon {\n    font-size: 8px;\n    align-content: center;\n    text-align: center;\n  }\n\n  .active {\n    color: map-get($success-color, 700);\n  }\n\n  .inactive {\n    color: map-get($danger-color, 500);\n  }\n}\n\nion-textarea,\nion-input {\n  --border-color: rgba(87, 87, 86, 1);\n  --padding-top: 5px !important;\n  --highlight-color: rgba(135, 135, 135, 1);\n  --highlight-color-focused: rgba(135, 135, 135, 1) !important;\n  --highlight-color-valid: rgba(135, 135, 135, 1) !important;\n  --highlight-color-invalid: rgba(174, 15, 10, 1) !important;\n}\n\nion-alert.custom-alert {\n  --backdrop-opacity: 0.7;\n}\n\nion-list.filtered-list {\n  display: flex;\n  flex-wrap: wrap;\n\n  span {\n    padding: 0.75rem 0;\n    margin: 0 0.75rem;\n    border-bottom: 1px solid map-get($light-color, 700);\n    width: 100%;\n  }\n}\n\nion-item.no-padding {\n  --padding-end: 0;\n  --padding-start: 0;\n}\n\n// Toast\nion-toast.snackbar-toast {\n  --box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);\n  --width: fit-content;\n  --border-radius: 0.75rem;\n  --white-space: pre-line;\n}\n\nion-toast.snackbar-toast {\n  &::part(container) {\n    background: #fff;\n    color: rgba(34, 36, 40, 1);\n    width: fit-content;\n    border-radius: 0.75rem;\n  }\n}\n\nion-toast.snackbar-toast.toast-success {\n  &::part(container) {\n    border: 1px solid rgba(45, 211, 111, 1);\n  }\n\n  &::part(icon) {\n    color: rgba(45, 211, 111, 1);\n    font-size: 1.25rem;\n  }\n}\n\nion-toast.snackbar-toast.toast-error {\n  &::part(container) {\n    border: 1px solid rgba(235, 68, 90, 1);\n  }\n\n  &::part(icon) {\n    color: rgba(235, 68, 90, 1);\n    font-size: 1.25rem;\n  }\n}\n\nion-toast.snackbar-toast.toast-right {\n  --start: right;\n  --box-shadow: none;\n  --background: none;\n\n  &::part(container) {\n    transform: translateY(72px) !important;\n    box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);\n  }\n}\n\n::ng-deep.mat-tab-label {\n  min-width: 25px !important;\n  padding: 5px;\n  background-color: transparent;\n  color: red !important;\n  font-weight: 700;\n}\n\n/* Styles for the active tab label */\n::ng-deep.mat-tab-label.mat-tab-label-active {\n  min-width: 25px !important;\n  padding: 5px;\n  background-color: transparent;\n  color: red !important;\n  font-weight: 700;\n}\n\n::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab\n  .mdc-tab-indicator__content--underline {\n  border-color: #2b2b2b;\n}\n\n// .mat-mdc-tab .mdc-tab-indicator__content--underline {\n//   border-color: #2b2b2b;\n// }\n\n::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active\n  .mdc-tab__text-label {\n  color: #2b2b2b;\n}\n\n.mat-mdc-paginator-navigation-next, .mat-mdc-paginator-navigation-previous {\n      box-shadow: none !important;\n}\n.g-bubble {\n  box-shadow: none !important;\n}\napp-modal-historic-segment {\n  display: block;\n  width: 100%;\n  height: 45em;\n}\n\n.column-flex {\n  display: flex;\n  flex-flow: column;\n}\n\n.master-icon {\n  background-color: map-get($warning-color, 300);\n  color: map-get($dark-color, 500);\n  border-radius: 10px;\n  align-self: flex-start;\n  font-size: 10px;\n  padding: 0px 9px;\n  margin: 6px 0;\n  line-height: 17px;\n  font-weight: 600;\n\n  &.center-horizontal {\n    place-self: center;\n  }\n}\n\nion-popover {\n  --min-width: 375px;\n  --max-width: 500px;\n}\n.custom-tooltip-menu {\n  padding: 8px;\n  \n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n\n  .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) {\n    background: none;\n  }\n  .mdc-evolution-chip__text-label {\n    color: #c00;\n  }\n}\n\n.custom-tooltip-menu .filter-title {\n  font-size: 12px;\n  font-weight: bold;\n  color: #333;\n  display: block;\n  margin-bottom: 4px;\n  border-bottom: 1px solid grey;\n}\n\n.custom-tooltip-menu .tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.custom-tooltip-menu mat-chip {\n  border: 1px solid #c00;\n  height: 20px;\n}\n\n.custom-tooltip-menu mat-chip mat-icon {\n  color: #c00 !important;\n  cursor: pointer;\n  font-size: 14px !important;\n  opacity: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-right: 0px !important;\n}\n.custom-tooltip-menu mat-chip .mdc-evolution-chip__text-label {\n  color: #c00 !important;\n  cursor: pointer;\n  font-size: 12px !important;\n  opacity: 1;\n}\n::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab .mdc-tab-indicator__content--underline  {\n  border: 1px solid #c00 !important;\n}\n::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {\n  color: #c00 !important;\n}\nion-toggle {\n  --handle-background-checked: rgba(174, 15, 10, 1);\n  --track-background-checked: rgba(174, 15, 10, 0.38);\n}\napp-list-contracts {\n  thead{\n    background: #F4F4F4 !important;\n  }\n}\napp-table-default{\n  thead{\n    background: #F4F4F4 !important;\n  }\n}\n.mat-expansion-panel-body{\n  padding: 0px !important;\n}\n.mat-mdc-paginator-range-actions {\n \n  overflow-wrap: anywhere !important;\n  flex-grow: 1;\n  justify-content: center !important;\n  position: relative !important;\n}\n.mat-mdc-paginator-container:has(.mat-mdc-paginator-page-size) .mat-mdc-paginator-range-actions .mat-mdc-paginator-range-label {\n  position: absolute !important;\n  left: 0 !important;\n}\n.mat-mdc-tab{\n  background-color: #F4F4F4 !important;\n}\n.mdc-tab--active{\n  background-color: white !important;\n}\n#paginator{\n  @media(max-width: 1025px){\n    width: 100%;\n  }\n\n}\nion-icon.search-icon-absolute {\n  position: absolute;\n  left: 16px;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  z-index: 3;\n}\n\nion-input.search-input {\n  label.input-wrapper {\n    --padding-start: 55px;\n  }\n\n  &.has-focus,\n  &.has-value {\n    .input-wrapper {\n      .label-text-wrapper {\n      }\n    }\n  }\n}\n.mat-mdc-icon-button[disabled] {\n    cursor: default;\n        pointer-events: auto;\n    opacity: .38;\n}\n.mat-mdc-unelevated-button[disabled] {\n    cursor: default;\n      pointer-events: auto;\n    opacity: .38;\n}\n\n.item-inner{\n  padding-right: 0 !important;\n}\n\n.mat-mdc-paginator-page-size-label {\n  @media (max-width: 496px) {\n    display: none !important;\n  }\n}\n.comentarios .mdc-text-field--outlined {\n  --mdc-outlined-text-field-outline-width: 1px;\n  --mdc-outlined-text-field-outline-color: #EFEFEF; /* Borda normal */\n  --mdc-outlined-text-field-focus-outline-color: #EFEFEF; /* Borda ao focar */\n  --mdc-outlined-text-field-container-shape: 4px;\n}\n// Gaps gerais\n.g-0 { gap: 0 !important; }\n.g-1 { gap: 0.25rem !important; }\n.g-2 { gap: 0.5rem !important; }\n.g-3 { gap: 1rem !important; }\n.g-4 { gap: 1.5rem !important; }\n.g-5 { gap: 3rem !important; }\n\n// Gaps horizontais\n.gx-0 { column-gap: 0 !important; }\n.gx-1 { column-gap: 0.25rem !important; }\n.gx-2 { column-gap: 0.5rem !important; }\n.gx-3 { column-gap: 1rem !important; }\n.gx-4 { column-gap: 1.5rem !important; }\n.gx-5 { column-gap: 3rem !important; }\n\n// Gaps verticais\n.gy-0 { row-gap: 0 !important; }\n.gy-1 { row-gap: 0.25rem !important; }\n.gy-2 { row-gap: 0.5rem !important; }\n.gy-3 { row-gap: 1rem !important; }\n.gy-4 { row-gap: 1.5rem !important; }\n.gy-5 { row-gap: 3rem !important; }\n.col {\n  flex: 1 0 0%;\n  max-width: 100%;\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n}\n\n.col-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n.col-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n.col-3 { flex: 0 0 23%; max-width: 23%; }\n.col-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n.col-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n.col-6 { flex: 0 0 48%; max-width: 48%; }\n.col-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n.col-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n.col-9 { flex: 0 0 73%; max-width: 73%; }\n.col-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n.col-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n.col-12 { flex: 0 0 98%; max-width: 98%; }\n\n/* Colunas responsivas */\n@media (min-width: 576px) { /* sm */\n  .col-sm-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n  .col-sm-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n  .col-sm-3 { flex: 0 0 23%; max-width: 23%; }\n  .col-sm-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n  .col-sm-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n  .col-sm-6 { flex: 0 0 48%; max-width: 48%; }\n  .col-sm-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n  .col-sm-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n  .col-sm-9 { flex: 0 0 73%; max-width: 73%; }\n  .col-sm-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n  .col-sm-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n  .col-sm-12 { flex: 0 0 98%; max-width: 98%; }\n}\n\n@media (min-width: 768px) { /* md */\n  .col-md-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n  .col-md-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n  .col-md-3 { flex: 0 0 23%; max-width: 23%; }\n  .col-md-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n  .col-md-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n  .col-md-6 { flex: 0 0 48%; max-width: 48%; }\n  .col-md-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n  .col-md-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n  .col-md-9 { flex: 0 0 73%; max-width: 73%; }\n  .col-md-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n  .col-md-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n  .col-md-12 { flex: 0 0 100%; max-width: 100%; }\n}\n\n@media (min-width: 992px) { /* lg */\n  .col-lg-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n  .col-lg-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n  .col-lg-3 { flex: 0 0 23%; max-width: 23%; }\n  .col-lg-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n  .col-lg-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n  .col-lg-6 { flex: 0 0 48%; max-width: 48%; }\n  .col-lg-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n  .col-lg-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n  .col-lg-9 { flex: 0 0 73%; max-width: 73%; }\n  .col-lg-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n  .col-lg-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n  .col-lg-12 { flex: 0 0 98%; max-width: 98%; }\n}\n\n@media (min-width: 1200px) { /* xl */\n  .col-xl-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n  .col-xl-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n  .col-xl-3 { flex: 0 0 23%; max-width: 23%; }\n  .col-xl-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n  .col-xl-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n  .col-xl-6 { flex: 0 0 48%; max-width: 48%; }\n  .col-xl-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n  .col-xl-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n  .col-xl-9 { flex: 0 0 73%; max-width: 73%; }\n  .col-xl-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n  .col-xl-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n  .col-xl-12 { flex: 0 0 98%; max-width: 98%; }\n}\n\n@media (min-width: 1400px) { /* xxl */\n  .col-xxl-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n  .col-xxl-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n  .col-xxl-3 { flex: 0 0 23%; max-width: 23%; }\n  .col-xxl-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n  .col-xxl-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n  .col-xxl-6 { flex: 0 0 48%; max-width: 48%; }\n  .col-xxl-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n  .col-xxl-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n  .col-xxl-9 { flex: 0 0 73%; max-width: 73%; }\n  .col-xxl-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n  .col-xxl-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n  .col-xxl-12 { flex: 0 0 98%; max-width: 98%; }\n}\n.ampliacao-panel{\n  max-width: 60vw !important;\n}\n.popover-content{\n  max-height: 150px;\n}\napp-form-projetos thead tr th{\n    font-family: \"Barlow\", sans-serif !important;\n    font-weight: 500 !important;\n    font-size: 18px !important;\n    line-height: 100% !important;\n  \n}\napp-form-projetos .mat-mdc-header-cell{\n    border: none !important;\n  \n}\napp-form-projetos .mat-mdc-form-field-subscript-wrapper {\n    display: none;\n}\n\n.mdc-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background\n {\n    border-color: #AE0F0A !important;\n    background-color: #AE0F0A !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
